{
  "common": {
    "no_access": "No tiene acceso a este módulo"
  },
  "settings": {
    "calendar": {
      "calendar_settings": "Configuración del calendario",
      "settings": "Configuración",
      "select_calendar_type": "Seleccionar tipo de calendario",
      "add_new_calendar_group": "Añadir nuevo grupo de calendarios",
      "add_new_equipment": "Añadir nuevo equipamiento",
      "new_calendar": "Nuevo calendario",
      "calendar_group_description": "Usa los grupos de calendarios para organizar y agrupar varios calendarios de forma eficaz.",
      "group": "Grupo",
      "manage_your_calendars_and_groups": "Administra tus calendarios y grupos",
      "groups": "Grupos",
      "create_group": "Crear un grupo",
      "create_calendar": "Crear calendario",
      "calendar_name": "Nombre del calendario",
      "group_duration": "Duración del grupo",
      "calendar_type": "Tipo",
      "action": "Acción",
      "round_robin": "Asignación rotativa",
      "event": "Evento",
      "group_name": "Nombre del grupo",
      "room_name": "Nombre de la sala",
      "group_description": "Descripción del grupo",
      "calendar_url": "URL del calendario",
      "calendars": "Calendarios",
      "date_updated": "Fecha de actualización",
      "status": "Estado",
      "action_dropdown": "Desplegable de acción",
      "calendar_list": "Servicios asociados a",
      "edit": "Editar",
      "duplicate": "Duplicar",
      "copy_embed_code": "Copiar el código de incrustación",
      "copy_permanent_link": "Copiar el enlace permanente",
      "copy_new_slug_link": "Copiar enlace de programación",
      "copy_scheduling_link": "Copiar el enlace de programación (obsoleto)",
      "deactivate_calendar": "Desactivar calendario",
      "move_to_group": "Mover al grupo",
      "delete_calendar": "Eliminar calendario",
      "delete_group": "Borrar",
      "delete_this_group": "Elimina este grupo",
      "activate_calendar": "Activar calendario",
      "duration": "Duración",
      "all": "Todo",
      "draft": "Borrador",
      "inactive": "Inactivo",
      "active": "Activo",
      "actions": "Actividades",
      "rearrange_calendars": "Reorganizar calendarios",
      "deactivate_all_calendars_in_group": "Desactivar todos los calendarios del grupo",
      "activate_all_calendars_in_group": "Activar todos los calendarios del grupo",
      "no_groups_found": "Tu búsqueda no coincide con ningún grupo de calendarios.",
      "no_groups_in_location": "Grupo Ordenar tus calendarios Me gusta Carpeta. Añadir calendarios a Grupo y Compartir a Individual Enlace de programación, permitiendo Reservar seleccionar varios calendarios.",
      "no_calendars_found": "Empieza a usar el calendario creando uno nuevo.",
      "no_calendars_found_search": "Tu búsqueda no coincide con ningún calendario.",
      "delete_calendar_message": "Estás a punto de eliminar el calendario. Cuando pulses borrar, también se borrarán todas las citas.",
      "delete_calendar_message_title": "¿Eliminar este calendario?",
      "duplicate_calendar_message": "Estás a punto de duplicar el calendario. Esto creará un nuevo calendario con la misma configuración que el calendario seleccionado.",
      "duplicate_calendar_message_title": "¿Duplicar este calendario?",
      "no_calendars_found_title": "No se ha encontrado ningún calendario",
      "no_groups_in_location_title": "No se han encontrado grupos",
      "delete_group_confirmation_title": "¿Eliminar este grupo?",
      "delete_group_confirmation": "¿Estás seguro de que deseas eliminar el grupo seleccionado?",
      "delete_group_confirmation_checkbox_title": "Eliminar los calendarios y citas asociados",
      "delete_group_confirmation_checkbox_description": "Al seleccionar esta opción, también se eliminarán los calendarios de este grupo, junto con todas las citas de esos calendarios.",
      "group_status_message_title": "¿{status} grupo & todos los calendarios asociados?",
      "calendar_status_message_title": "¿{status} este calendario?",
      "calendar_status_message": "Estás a punto de {status} el calendario.",
      "group_status_active_message": "¿Seguro que quieres activar este grupo? Todos los calendarios dentro del grupo también se activarán y estarán disponibles para reservas.",
      "group_status_inactive_message": "¿Seguro que quieres desactivar este grupo? Todos los calendarios del grupo también se desactivarán y estarán disponibles para reservas.",
      "coming_soon": "Próximamente",
      "select": "Seleccionar",
      "15mins": "15 minutos",
      "cancel": "Cancelar",
      "save": "Guardar",
      "create": "Crear",
      "select_calendar_group": "Seleccionar grupo de calendarios",
      "move_calendar_confirmation": "El enlace heredado dejará de funcionar una vez que realice este cambio. Confirme seleccionando la casilla.",
      "previously_called_unassigned": " (Anteriormente conocido como no asignado)",
      "scheduling_type": "Elige el tipo de calendario",
      "scheduling_type_description": "Selecciona un Tipo de calendario para configurar tu calendario y personalizar cómo está programado Cita.",
      "service_menu_name": "Nombre del menú de servicios",
      "template": "Plantilla",
      "select_template": "Seleccionar plantilla",
      "group_url": "URL del grupo",
      "template_description": "Ahora tienes la opción de seleccionar las plantillas clásicas o Neo para la vista de grupo.",
      "rooms": "Salas",
      "rooms_name": "Nombre",
      "rooms_description": "Descripción",
      "rooms_modal_description": "Añadir o editar una sala.",
      "rooms_capacity": "Capacidad total",
      "no_rooms_in_location_title": "No se han encontrado salas",
      "no_rooms_in_location": "No se han encontrado salas en esta ubicación",
      "no_equipments_in_location": "No se ha encontrado ningún equipamiento en esta ubicación",
      "equipments": "Equipamiento",
      "equipment_name": "Nombre",
      "equipment_name_search": "Nombre del equipo",
      "equipment_description": "Descripción",
      "equipment_modal_description": "Añadir o editar un equipamiento.",
      "add_equipment": "Añadir/editar equipamiento",
      "add_room": "Añadir/editar sala",
      "equipment_quantity": "Cantidad total",
      "equipment_outOfService": "Cantidad fuera de servicio",
      "no_equipments_in_location_title": "No se ha encontrado ningún equipamiento",
      "delete_this_equipment": "Eliminar este equipamiento",
      "delete_this_rooms": "Eliminar esta sala",
      "delete_equipment_confirmation": "¿Estás seguro de que deseas eliminar este equipamiento? También se eliminará de todos los calendarios vinculados.",
      "delete_rooms_confirmation": "¿Estás seguro de que deseas borrar esta sala? También se eliminará de todos los calendarios vinculados.",
      "add_new_calendar_equipments": "Añadir nuevo equipamiento",
      "no_equipments_found": "Tu búsqueda no coincide con ningún equipamiento.",
      "no_rooms_found": "Tu búsqueda no coincide con ninguna sala.",
      "add_new_calendar_rooms": "Añadir nueva sala",
      "rooms_disable": "Habitación para discapacitados",
      "equipments_disable": "Desactivar equipo",
      "equipments_activate": "Activar el equipamiento",
      "rooms_activate": "Activar sala",
      "create_equipments": "Crear equipamiento",
      "create_rooms": "Crear sala",
      "select_calendar_rooms_title": "Selecciona calendario",
      "select_calendar_rooms_description": "Puedes seleccionar varios calendarios para asociarlos con las salas.",
      "select_calendar_equipments_title": "Selecciona calendario",
      "select_calendar_equipments_description": "Puedes seleccionar un calendario para asociarlo con el equipamiento.",
      "disable_equipment_title": "{status} equipamiento",
      "disable_room_title": "{status} sala",
      "equipments_status_message": "¿Seguro que desea {status} este equipamiento?",
      "rooms_status_message": "¿Estás seguro de que deseas {status} esta sala?",
      "calendar_resource_disclaimer": "Esto podría afectar la disponibilidad en los calendarios de servicio asociados.",
      "equipment_disclaimer": "Nota: Al habilitar el equipamiento posteriormente, se volverá a conectar automáticamente a los calendarios con los que está asociado",
      "room_disclaimer": "Nota: Al habilitar la sala posteriormente, se volverá a conectar automáticamente a los calendarios a los que está asociada",
      "equipment_tab_name": "Equipamiento",
      "rooms_tab_name": "Salas",
      "manage_your_rooms": "Gestiona aquí las salas de tu negocio",
      "manage_your_equipments": "Gestiona aquí el equipamiento de tu empresa",
      "select_service_calendar_description_equipments": "Puedes seleccionar varios calendarios de servicio para asociarlos con el equipamiento.",
      "select_service_calendar_description_rooms": "Puedes seleccionar varios calendarios de servicio para asociarlos a las salas.",
      "service_menus": "Menú de servicios",
      "manage_your_calendars_groups_and_service_menus": "Gestiona tus calendarios, grupos y menú de servicios",
      "new_service_menu": "Crear menú de servicios",
      "deactivate_service_menu": "Desactivar el menú de servicios",
      "delete_service_menu": "Eliminar este menú de servicios",
      "delete_service_menu_confirmation": "¿Estás seguro de que deseas eliminar este menú de servicios?",
      "service_menu_status_message_title": "{status} ¿este menú de servicios?",
      "service_menu_status_message": "Estás a punto de {status} el menú de servicios.",
      "no_service_menus_in_location_title": "Crea tu menú de servicio personalizado",
      "add_new_service_menu": "Añada nuevo menú de servicio",
      "no_service_menus_in_location": "Empieza por crear un nuevo menú de servicios y añádele grupos",
      "no_service_menu_found": "No se ha encontrado ningún menú de servicios",
      "no_service_menu_found_desc": "Tu búsqueda no coincide con ningún menú de servicios.",
      "apply": "Aplicar",
      "troubleshoot_calendar": "Solucionar problemas del calendario",
      "round_robin_booking": "Asignación rotativa",
      "round_robin_description": "Distribuye las citas entre los miembros del equipo en orden rotativo.",
      "round_robin_example": "Por ejemplo: llamadas de ventas, sesiones de incorporación.",
      "unassigned_booking": "Calendario de eventos",
      "unassigned_description": "Para programar eventos presenciales sin estar asociados a un anfitrión.",
      "unassigned_example": "Por ejemplo: conferencias, seminarios públicos, exposiciones.",
      "event_booking_alert_title": "Importante",
      "event_booking_alert_message": "Este tipo de calendario tiene diferencias clave.",
      "event_booking_learn_more": "Más información",
      "event_booking_tooltip_title": "Aspectos a tener en cuenta:",
      "event_booking_tooltip_content": "• Los calendarios de eventos no tienen usuarios, por lo que no se pueden asignar reuniones a ningún usuario.\n• Debido a que no se ha asignado ningún usuario, no se admiten herramientas dinámicas de enlace de reuniones (Zoom, Google Meet, Microsoft Teams). Para utilizar reuniones en línea, copia un enlace de conferencia estático de cualquier herramienta y pégalo en la ubicación de la reunión.\n• Debido a que no se ha asignado ningún usuario, las reuniones no se sincronizan con el calendario de un usuario desde la configuración de Calendario → Conexiones. Los calendarios de conflicto añadidos allí no se consideran.\n• Las reuniones solo se sincronizan con el calendario seleccionado en Sincronización Externa para este calendario.\n• Los eventos se extraen y se envían únicamente al calendario externo seleccionado.\n• Solo se puede conectar un único calendario de Google mediante la sincronización externa.",
      "class_booking": "Reserva de clase",
      "class_booking_description": "Un anfitrión se reúne con varios participantes.",
      "class_booking_example": "Por ejemplo: webinarios, formación en grupo, clases en línea.",
      "collective_booking": "Reserva colectiva",
      "collective_booking_description": "Varios anfitriones se reúnen con un participante.",
      "collective_booking_example": "Por ejemplo: entrevistas grupales, revisiones de comité.",
      "service_booking": "Reserva de servicio",
      "service_booking_description": "Programación fluida para empresas de servicios.",
      "service_booking_example": "Por ejemplo: reservas en balnearios, servicios de reparación, consultas.",
      "personal_booking": "Reserva personal",
      "personal_booking_description": "Programa reuniones individuales con un miembro determinado del equipo.",
      "personal_booking_example": "Por ejemplo: reuniones con clientes, consultas privadas.",
      "personal": "Personal",
      "explore_more_types": "Explora más tipos",
      "no_calendars_added": "Aún no hay calendarios; ¡configure uno!",
      "no_calendars_added_description": "Crea tu primer calendario para iniciar la Programación sin esfuerzo.",
      "no_groups_added": "Todavía no hay grupos, ¡empiece a organizar!",
      "no_calendars_yet": "Todavía no hay calendarios",
      "no_groups_yet": "Todavía no hay grupos",
      "no_calendars_access": "Todavía no se ha creado calendarios. Una vez creada un calendario, aparecerá aquí. Tú no tienes acceso para crear un calendario. Ponte en contacto con tu administradorSi es necesario.",
      "no_groups_access": "No se ha configurado ningún grupo todavía. Una vez que se haya creado un grupo, aparecerá aquí. Tú no tienes acceso para crear un grupo. Ponte en contacto con tu administradorSi es necesario.",
      "no_groups_added_description": "Utiliza Grupo para mantener tus calendarios estructurados. Añadir calendarios a un grupo y compartir a un grupo Individual Enlace de programación para la reserva de Sencillo.",
      "group_success_message": "Grupo es creada con éxito. Tú puedes ahora incluir calendarios en este Grupo.",
      "choose_calendars": "Elija calendarios",
      "do_it_later": "Lo haré más tarde",
      "add_calendars_to_group": "Añada calendarios al grupo",
      "select_calendars_to_add": "Selecciona cada calendario que quieras incluir en el Grupo {name}",
      "add_calendars": "Añadir calendario(s)",
      "continue": "Continuar",
      "conflicting_calendars": "Calendarios en conflicto",
      "conflicting_calendars_description": "Los calendarios A la zaga/retrasado ya forman parte de Otro Grupo. ¿Quieres moverlos a tu Nuevo Grupo, <b>{name}</b>?",
      "group_associated_with": "Grupo Actual",
      "move_calendar_consent": "Habilito Moviendo estos calendarios al Nuevo Grupo.",
      "calendars_moved_successfully": "cada calendarios de Seleccionado se han movido correctamente a {name}.",
      "new_group": "Nuevo grupo",
      "back": "Atrás",
      "share_otl": "Comparte tu disponibilidad cada Fecha con un enlace único que vence después a la reserva, garantizando Gestionar Acceso.",
      "copied_to_clipboard": "Copiado al portapapeles",
      "generate_link": "Generar nuevo enlace",
      "generate_link_error": "No se ha podido generar el enlace de un solo uso. Vuelva a intentarlo",
      "share_schedule_link": " El Enlace de programación se determina Vía the Slug. Modifica el Slug y el Enlace de programación se adaptará automáticamente a la modificación.",
      "share_permanent_link": "Ideal para Embudos, Sitio web Redireccionamiento, O anuncios, el enlace permanente se mantiene constante, la Vía Slug Dinámico no se ve afectada.",
      "copy": "Copiar",
      "share_embed_code": "Ubica este código in tu HTML donde quieres que aparezca tu Widget {embedType}.",
      "scheduling_link": "Enlace de programación",
      "permanent_link": "Enlace permanente",
      "one_time_link": "Enlace de un solo uso",
      "embed_code": "Código de inserción",
      "loading": "Cargando...",
      "share_group": "Grupo para compartir",
      "edit_group": "Editar grupo",
      "more_options": "Más opciones",
      "share_calendar": "Compartir calendario",
      "edit_calendar": "Editar calendario",
      "troubleshoot_calendar_link": "Solucionar problemas del calendario",
      "calendar_config_success": "Has configurado correctamente tu calendario personal/de grupo",
      "close": " Cerrar",
      "added_calendars": "Calendario(s) agregado(s)",
      "select_calendars": "Seleccionar calendario(s)",
      "settings_confirmation": "Al proceder, confirma este Dinámico.",
      "consent_checkbox_title": "Entiendo y acepto estos cambios.",
      "confirm": "Confirmar",
      "create_group_access_disabled": "Tú no tienes Autorización para crear un Grupo. Ponte en contacto con el administrador para obtener acceso.",
      "create_calendar_access_disabled": "No tienes autorización para crear un calendario. Ponte en contacto con el administrador para obtener acceso.",
      "create_room_access_disabled": "No tiene permiso para gestionar salas. Póngase en contacto con el administrador para obtener acceso.",
      "create_equipment_access_disabled": "No tiene permiso para gestionar el equipo. Póngase en contacto con el administrador para obtener acceso.",
      "preview_booking_widget": "Vista previa del widget de reserva",
      "share_service_menu": "Menú de servicio para compartir",
      "back_message": "Volver a la lista de calendarios",
      "service_calendars": "Calendarios de servicio",
      "owned_by": "Vía en propiedad",
      "owned_by_anyone": "Cualquiera",
      "owned_by_me": "Yo",
      "all_groups": "Todos los grupos",
      "all_calendars": "Todos los calendarios",
      "not_grouped": "No agrupado",
      "delete_group_desc": "¿Estás seguro de que quieres eliminar este grupo? Esto también eliminará todos los miembros de los calendarios con este grupo.",
      "calendar_listing_title": "Listado de calendario",
      "calendar_group_name": "Nombre del calendario/grupo",
      "success": "Correcto",
      "my_calendar": "mi-calendario",
      "service_calendar_description": "Programación sin interrupciones para empresas de servicios."
    },
    "preferences": {
      "preferences": "Preferencias",
      "my_preferences": "Mi preferencia",
      "account_preferences": "Preferencias de cuenta",
      "user_preferences": "Preferencias de usuario",
      "set_preferences": "Configura tus preferencias para tu cuenta.",
      "scheduling_options": "Opciones de programación",
      "meeting_location": "Lugar de la reunión",
      "zoom": "Zoom",
      "save_preferences": "Guardar preferencias",
      "in_app_preferences": "Preferencias de la aplicación",
      "set_start_day": "Configurar preferencias como el día de inicio para la aplicación",
      "view_options": "Ver opciones",
      "services": "Servicios",
      "feature_toggle_aria": "Conmutador de funciones",
      "week_starts_on": "La semana empieza el",
      "sunday": "Domingo",
      "widget_preferences": "Preferencias de widgets",
      "set_widget_language": "Configurar preferencias como el idioma para el widget",
      "language_and_region": "Idioma y región",
      "language": "Idioma",
      "english": "Inglés",
      "time_format": "Formato de tiempo",
      "time_format_value": "13:30",
      "monday": "Lunes",
      "custom_meeting_location": "Ubicación de reunión personalizada",
      "view_appointments_in_1": "Ver citas en",
      "timezone_uses_details_1": "Utilizaremos esta Zona horaria para mostrar las horas de las Citas en toda la Aplicación y en tus correos electrónicos relacionados con las Citas, solo para ti. No afectará a su disponibilidad ni a la forma en que otros reservan con usted.",
      "business_timezones_1": "Zona horaria empresarial",
      "business_timezones_tooltip_1": "Mensaje: Al elegir esta opción, te aseguras de que tu Preferencia de visualización se alinee con la Zona horaria de la Empresa seleccionada. Si la zona horaria de la Empresa cambia, tu zona horaria de visualización se ajustará automáticamente para coincidir.",
      "recommended_timezones": "Zonas horarias recomendadas",
      "all_timezones": "Todas las zonas horarias"
    },
    "availability": {
      "availability": "Disponibilidad",
      "my_availability": "Mi disponibilidad",
      "my_availability_and_booking_rules": "Programación de disponibilidad",
      "my_availability_and_booking_rules_description": "Establezca cuándo se pueden agendar reuniones según la disponibilidad del personal.",
      "account_availability": "Disponibilidad de la cuenta",
      "timezone": "Zona horaria",
      "working_hours": "Horario laboral",
      "set_recurring_hours": "Establece tus horas de trabajo recurrentes para la reunión",
      "select_one": "Seleccionar uno",
      "sunday": "Domingo",
      "monday": "Lunes",
      "tuesday": "Martes",
      "wednesday": "Miércoles",
      "thursday": "Jueves",
      "friday": "Viernes",
      "saturday": "Sábado",
      "widget_preferences": "Preferencias de widgets",
      "set_widget_language": "Configurar preferencias como el idioma para el widget",
      "language_and_region": "Idioma y región",
      "language": "Idioma",
      "english": "Inglés",
      "copy_to_all": "Copiar a todos",
      "save_availability": "Guardar disponibilidad",
      "add_time": "Añadir hora",
      "to": "Para",
      "select_time": "Seleccionar hora",
      "add_user": "Añadir usuario",
      "accessRestricted": {
        "header": "Acceso restringido",
        "message": "No eres parte de esta cuenta. Para obtener acceso, agréguese a esta cuenta a través de Configuración de agencia > Teams > Editar Miembro del Equipo, y asigne la cuenta bajo «Roles y Permisos».",
        "contact_admin": "Esta página es pública únicamente para los administradores. Ponte en contacto con el administrador para obtener ayuda.",
        "button_text": "Ve a Configuración de la Agencia."
      },
      "schedule": {
        "edit_schedule": "Editar programación",
        "schedule_name": "Nombre de la programación",
        "schedule_name_required": "El nombre de la programación es obligatorio",
        "timezone": "Zona horaria",
        "timezone_placeholder": "Seleccionar uno",
        "start_time": "Hora de inicio",
        "end_time": "Hora de finalización",
        "add_availability_hour": "Añadir hora de disponibilidad",
        "remove_availability_hour": "Eliminar hora de disponibilidad",
        "unavailable": "No disponible",
        "schedule_created": "Programación creada correctamente",
        "schedule_updated": "Programación actualizada correctamente",
        "calendars_selected": "{count} calendario",
        "calendars_selected_multiple": "{count} calendarios",
        "select_users_placeholder": "Buscar usuarios",
        "edit_default_schedule": "Editar esta programación",
        "customize_event_type_schedule": "Personalizar la programación solo para este calendario",
        "multi_user_description": "Actualizar disponibilidad para <b>{count} usuarios seleccionados</b> - {calendar}",
        "bulk_edit_warning_banner": "Edición masiva activada. Los cambios sobrescribirán las programaciones existentes para todos los usuarios seleccionados.",
        "bulk_edit_slot_applies_to_all": "La franja horaria seleccionada se aplicará a todos los usuarios seleccionados.",
        "bulk_edit_slot_applies_to_selected": "La franja horaria seleccionada se aplicará a {count} usuario(s) seleccionado(s).",
        "bulk_edit_applies_to_all": "Los cambios se aplicarán a los {count} usuarios seleccionados.",
        "bulk_edit_weekly_hours": "Editar en bloque las horas semanales",
        "bulk_edit_weekly_hours_title": "Editar en bloque las horas semanales",
        "bulk_edit_weekly_hours_desc": "Esto sustituirá las horas semanales para todos los usuarios enumerados a continuación.",
        "edit_now": "Editar ahora",
        "bulk_edit": "Edición en bloque",
        "choose_days_weekly_hours": "Elige el/los día(s) para establecer el horario semanal",
        "assign_to": "Asignar a:",
        "configure_weekly_hours": "Configurar Horas Semanales",
        "selected_users": "Usuarios seleccionados:",
        "bulk_edit_select_users": "Seleccione usuarios para aplicar",
        "bulk_edit_select_users_placeholder": "Seleccionar a los miembros del equipo...",
        "bulk_edit_select_at_least_one": "Seleccione al menos un usuario.",
        "bulk_edit_editing_for": "Edición para:",
        "bulk_edit_applies_to": "Se aplica a:",
        "bulk_edit_user_count": "{count} usuario",
        "bulk_edit_users_count": "{count} usuarios",
        "show_less": "Mostrar menos",
        "more": "más",
        "confirm_delete": "Confirmar eliminación",
        "confirm": "Confirmar",
        "delete_user_date_confirm": "¿Está seguro de que quiere eliminar las horas específicas de la fecha para <b>{userName}</b> el <b>{date}</b>?",
        "delete_date_confirm": "¿Está seguro de que desea eliminar las horas específicas de la fecha para todos los usuarios en <b>{date}</b>?",
        "selected_calendar": "calendario seleccionado",
        "edit_schedule_alert": "Las actualizaciones hechas aquí se aplicarán a",
        "schedule": "Programar",
        "no_availability": "No hay disponibilidad",
        "date_specific_hours_show_more": "más",
        "date_specific_hours_show_less": "menos",
        "date_specific_hours_recurring_meetings_enabled": "No se pueden añadir horarios para fechas determinadas porque esta programación está vinculada a un calendario con reuniones recurrentes habilitadas. Para continuar, deshabilite las reuniones recurrentes.",
        "recurring_incompatible_with_date_hours": "Las reuniones recurrentes no se pueden habilitar porque la agenda del usuario tiene horas específicas para cada fecha, lo cual es incompatible.",
        "incompatible_schedule_with_recurring": "La programación {user} incluye horas específicas para fechas, lo cual es incompatible con las reuniones recurrentes.",
        "incompatible_schedule_with_recurring_calendar": "La programación contiene horas específicas para fechas, lo cual es incompatible con las reuniones recurrentes.",
        "recurring_meetings_enabled_multi_user": "Las reuniones recurrentes no son compatibles con calendarios que incluyan varios miembros del equipo o cuando un miembro del equipo tiene horas específicas para fechas añadidas a su horario.",
        "weekdays": "Días laborables, {timeRange}",
        "weekdays_hours_vary": "Días laborables, el horario puede variar",
        "weekend": "Fin de semana, {timeRange}",
        "weekend_hours_vary": "Fin de semana, el horario puede variar",
        "days_hours_vary": "{days}, el horario puede variar",
        "date_specific_hours_tab_name": "horas específicas de una fecha",
        "date_specific_hours": "{count} horarios para fechas determinadas",
        "date_specific_hours_1": "1 horario para una fecha determinada",
        "weekly_hours": "Horas semanales",
        "custom_schedule": "Programación personalizada",
        "select_schedule": "Selecciona un horario",
        "no_schedules_found": "No se han encontrado programaciones",
        "untitled": "Sin título",
        "error_updating_schedules": "Error al actualizar los horarios",
        "daily": "A diario",
        "weekly": "Semanalmente",
        "monthly": "Mensualmente",
        "custom": "Personalizado",
        "this_is_required": "Esto es Obligatorio",
        "search": "Buscar",
        "edit_hours": "Editar horas",
        "schedule_name_duplicate": "Ya existe una programación con ese nombre",
        "delete_schedule_title": "¿Borrar la programación «{scheduleName}»?",
        "delete_schedule_description": "Esta acción no se puede deshacer. ¿Seguro que desea continuar?",
        "delete_schedule_negative_text": "Cancelar",
        "delete_schedule_positive_text": "Sí, eliminar.",
        "active_on": "Activo en",
        "weekly_working_hours": "Horario laboral semanal",
        "weekly_working_hours_subtext": "Seleccionar los días y horarios en los que trabaja",
        "copy_availability_hour": "Copiar hora de disponibilidad",
        "mins": "Minutos",
        "hours": "Horas",
        "save_weekly_hours": "Guarda horas semanales",
        "save_date_specific_hours": "Guardar horas específicas de una fecha",
        "update_weekly_hours_for_users": "Actualizar las horas semanales para {count} usuarios",
        "set_date_specific_hours_for_users": "Establecer horarios específicos por fecha para {count} usuarios",
        "set_date_specific_hours_for_user": "Establecer horas específicas para una fecha"
      }
    },
    "connections": {
      "connections": "Conexiones",
      "connect": "conectar",
      "conferencing": "Conferencias",
      "my_connections": "Mis conexiones",
      "account_connections": "Conexiones de cuenta",
      "connection_preferences": "Preferencias de conexión",
      "manage_calendars_conferencing_channels": "Gestionar calendarios y canales de conferencias",
      "main_integration_calendar": "Calendario de integración principal",
      "event_integration_calendar": "Los eventos creados en un calendario del sistema del que formes parte también se crearán en este calendario integrado",
      "2way_sync": "Sincronización de bidireccional: crea eventos del sistema a partir de eventos reservados en el calendario integrado principal",
      "calendars": "Calendarios",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Comprobar si hay conflictos",
      "choose_accounts_to_connect": "Selecciona las cuentas que desees conectar",
      "payments": "Pagos",
      "stripe": "Stripe",
      "ads": "Anuncios",
      "local_service_ads": "Anuncios de servicios locales",
      "fire_workflow": "Disparar los activadores del flujo de trabajo para eventos reservados mediante sincronización bidireccional",
      "connect_google_outlook": "Conecta tu cuenta de Google/Outlook/iCloud para poder seleccionar el calendario principal.",
      "execute_automation": "Ejecutar la automatización",
      "save": "Guardar",
      "lsa": "Anuncios de Local Services Ads",
      "no_write_access": "No tienes acceso de escritura a este calendario",
      "connection_remove_confirmation": "Estás a punto de eliminar esta integración",
      "active": "Activo",
      "icloud": {
        "title": "Integración de iCloud",
        "description": "Se requiere una autenticación de dos factores y una contraseña específica de la aplicación para conectar la cuenta.",
        "email": "Dirección de correo electrónico de iCloud",
        "password": "Contraseña de iCloud",
        "connect": "Conectar",
        "cancel": "Cancelar"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Seleccionar un contacto",
    "start_time": "Hora de inicio",
    "unassigned": "Sin asignar",
    "end_time": "Hora de finalización",
    "search_by_name_email_phone_or_company": "Buscar por nombre, correo electrónico, teléfono o empresa",
    "add_new": "Añadir nuevo",
    "pick_from_available_contacts": "O seleccionar de entre los contactos disponibles",
    "book_appointment": "Reservar Cita",
    "add_blocked_off_time": "Añadir tiempo de descanso bloqueado",
    "recommended_timezones": "Zonas horarias recomendadas",
    "all_timezones": "Todas las zonas horarias",
    "calendar": "Calendario",
    "repeat": "Repetir",
    "date_and_time": "Fecha y hora",
    "close": "Cerrar",
    "team_member": "Miembro del equipo",
    "recurring_booking": "Reserva recurrente",
    "one_slot_booking": "Reserva de una sola franja horaria",
    "event_type": "Tipo de evento",
    "occurrences_booked": "sesiones se reservarán",
    "repeats": "Repite",
    "booking_details": "Detalles de la reserva",
    "showing_slots_in_this_timezone": "Mostrando franjas horarias en esta zona horaria:",
    "update_contact_tz": "Actualice también la zona horaria del contacto a",
    "date": "Fecha",
    "slot": "Franja horaria",
    "calendar_default": "Calendario por defecto",
    "custom": "Personalizado",
    "meeting_notes": "(p. ej.) Notas de reunión para nuestra próxima cita",
    "out_of_office": "(p. ej.) ¡Fuera de la oficina durante toda la semana!",
    "standard": "Por defecto",
    "appointment_title": "Título de la cita",
    "event_title": "Título del evento",
    "appt_with_bob": "(p. ej.) Cita con Bob",
    "vacation": "(p. ej.) Vacaciones",
    "show_notes": "Mostrar notas",
    "hide_notes": "Ocultar notas",
    "additional_preferences": "Preferencias adicionales",
    "meeting_location": "Lugar de la reunión",
    "appointment_status": "Estado de la cita",
    "appt_description": "Descripción de la cita",
    "recurring_details": "Detalles recurrentes",
    "event_description": "Descripción del evento",
    "in_contact_timezone": "En la zona horaria del contacto",
    "vacation_message": "¿Te vas de vacaciones? ¿Estás tomándote un descanso? Bloquea los horarios en tu calendario para evitar que los clientes reserven citas. Las citas existentes seguirán en el calendario.",
    "contact": "Contacto",
    "delete": "Borrar",
    "cancel": "Cancelar",
    "back": "Atrás",
    "pick_available_contacts": "O seleccionar de entre los contactos disponibles",
    "no_contacts_found": "No se han encontrado contactos",
    "found": "encontrado",
    "select_one": "Seleccionar uno",
    "tz_tooltip": "Esto solo es relevante si utilizas valores personalizados, como appointment_start_time appointment_end_time appointment_timezone, etc., en la comunicación saliente con tus clientes. Y lo que hace simplemente es convertir los detalles antes mencionados en su hora local.",
    "meeting_location_tooltip": "La ubicación de la reunión se establecerá según lo configurado en el calendario.",
    "appt_meeting_location_tooltip": "El usuario puede establecer la ubicación de la reunión específica para la cita.",
    "gmeet_tooltip": "Asegúrate de que el miembro del equipo respectivo tenga un calendario de Google configurado como su calendario principal.",
    "zoom_tooltip": "Asegúrate de que el miembro del equipo respectivo tenga Zoom integrado.",
    "enter_meeting_location": "Introducir la ubicación de la reunión",
    "save_appointment": "Guardar cita",
    "save_event": "Guardar evento",
    "search_contacts": "Buscar por nombre, correo electrónico, teléfono o empresa",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Zona horaria personalizada",
    "system_timezone": "Zona horaria del sistema",
    "contact_timezone": "Zona horaria del contacto",
    "account_timezone": "Zona horaria de la cuenta",
    "an_error_occurred": "Se ha producido un error"
  },
  "popup": {
    "calendar": "Calendario",
    "appointment_owner": "Propietario de la cita",
    "source": "Fuente",
    "booked_by": "Reservada por",
    "view_activity_log": "Ver registro de actividad",
    "status": "Estado",
    "cancel_appointment": "Cancelar la cita",
    "cancel_all": "Cancelar todo",
    "google_event": "Evento de Google",
    "outlook_event": "Evento de Outlook",
    "blocked_slot": "Franja horaria bloqueada",
    "appointment": "Cita",
    "confirmed": "Confirmada",
    "unconfirmed": "Sin confirmar",
    "cancelled": "Cancelada",
    "showed": "Asistido",
    "no_show": "No se presentó",
    "invalid": "No válida",
    "more": "Más",
    "less": "Menos",
    "edit": "Editar",
    "reschedule_all": "Reprogramar todo",
    "guests": "Invitados",
    "guest_count": "Recuento de invitados"
  },
  "create_calendar": {
    "calendar_name": "Nombre del calendario",
    "calendar_logo": "Logotipo del calendario",
    "select_team_member": "Seleccionar a los miembros del equipo",
    "select_single_team_member": "Seleccionar un miembro del equipo",
    "eg_outbound_reach": "(p. ej.) Alcance saliente",
    "description": "Descripción",
    "amount": "Cantidad",
    "description_placeholder": "Escribir una descripción",
    "meeting_duration": "Duración de la reunión",
    "meeting_location": "Lugar de la reunión",
    "seats_per_class": "Plazas por clase",
    "group": "Grupo",
    "custom_url": "URL personalizada",
    "meeting_invite_title": "Título de la invitación a la reunión",
    "event_color": "Color del evento",
    "availability_type": "Tipo de disponibilidad",
    "new_calendar": "Nuevo calendario",
    "add_description": "Añadir descripción",
    "remove_description": "Eliminar descripción",
    "booking_availability": "Disponibilidad de reservas",
    "slug_tooltip": "Personaliza la URL del widget de reservas.",
    "meeting_location_tooltip": "Los enlaces de reuniones se muestran en Eventos del calendario como la «Ubicación de la reunión» y te permiten añadir cosas como los enlaces de Zoom para el evento.",
    "advanced_settings": "Configuración avanzada",
    "show_more_schedule": "Mostrar más",
    "show_more_helper_text": "Para personalizar aún más su horario comercial, diríjase a la configuración avanzada.",
    "reschedule_preference": "Preferencia de reprogramación",
    "reschedule_preference_subtext": "Si un {contactLabel} reprograma una cita:",
    "reassign_through_round_robin": "Reasignar mediante rotación",
    "keep_same_assinged_user": "Mantener el mismo propietario de la cita",
    "new_appointment_preference": "Preferencia de nueva cita",
    "new_appointment_preference_text": "Reservar siempre con el usuario asignado al {contactLabel}.",
    "new_appointment_preference_subtext": "Reservar nuevas citas con el usuario asignado al {contactLabel} en lugar de utilizar la programación rotativa.",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "service_calendar_name": "Nombre del servicio",
    "service_logo": "Logotipo del servicio",
    "service_select_team_member": "Selecciona miembro del personal",
    "service_duration": "Duración del servicio",
    "appointment_invite_title": "Título de la invitación a la cita",
    "payment_placeholder": "Introduce una descripción que se mostrará al usuario, informándole sobre el pago",
    "deposit_amount": "Importe del depósito",
    "collect_deposit_amount": "Aceptar pago parcial",
    "percentage": "Porcentaje",
    "total_amount": "Importe total",
    "enter_meeting_location": "Introducir la ubicación de la reunión",
    "accept_payments": "Aceptar pagos",
    "aria": {
      "should_accept_payment": "Debe aceptar el pago"
    },
    "calendar_name_tooltip": "Nombre del calendario que se mostrará en el widget de reserva.",
    "booking_availability_tooltip": "Establezca los días y las horas durante los cuales se pueden hacer reservas. Estos son sus horarios comerciales semanales por defecto que se muestran a los usuarios al seleccionar una franja horaria.",
    "select_team_member_tooltip": "Seleccione al miembro(s) o los miembros del equipo que asistirán a esta reunión.",
    "seats_per_class_tooltip": "Establezca el número máximo de participantes permitidos para reservar esta clase. Una vez que se completen todos los asientos, la franja horaria ya no estará disponible para su reserva.",
    "meeting_color": "Color de las conferencias",
    "meeting_duration_tooltip": "Establece la duración de la reunión."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Consejo rápido",
      "timezone_change_tip": "Las zonas horarias se pueden cambiar en cualquier momento en las preferencias de zona horaria",
      "save": "Guardar cambios",
      "close": "Cerrar",
      "meeting_details": "Detalles básicos",
      "availability": "Disponibilidad",
      "forms_and_payment": "Formularios & pago",
      "notifications_and_additional_options": "Notificaciones & opciones adicionales",
      "connections": "Conexiones",
      "customizations": "Personalizaciones",
      "create": "Crear",
      "edit": "Editar",
      "equipments": "Salas y equipamiento",
      "service_details": "Detalles del servicio",
      "booking_rules": "Reglas de reserva",
      "advanced_settings": "Configuración avanzada",
      "form_and_confirmation": "Formulario & confirmación",
      "payments": "Pagos",
      "notifications_and_policies": "Notificaciones & políticas",
      "widget_appearance": "Apariencia del widget",
      "saving_changes": "Solo un minuto — Guardando el último Dinámico...",
      "calendar_id": "ID del calendario",
      "saveCalendarSuccess": "Calendario guardado correctamente",
      "external_sync": "Sincronización externa",
      "booking_channels": "Canales de reserva",
      "meeting_location": "Lugar de la reunión",
      "staff_location": "Personal & ubicación"
    },
    "meeting_details": {
      "meeting_location": "Lugar de la reunión",
      "meeting_location_label": "Lugar de la reunión",
      "enter_meeting_location": "Introducir la ubicación de la reunión",
      "click_to_upload": "Haz clic para cargar",
      "square": "Cuadrado",
      "circle": "Círculo",
      "remove_logo": "Quitar el logotipo",
      "meeting_invite_title_tooltip": "Este es el título de la reunión del calendario que se muestra en la vista de lista de citas, en la vista de calendario y en los calendarios de terceros.",
      "event_color_tooltip": "Elegir un color para este evento de reserva. Los colores se sincronizan con los eventos en Google Calendar.",
      "enter_a_name": "Introduzca un nombre.",
      "enter_an_event_title": "Introduce un título para el evento.",
      "high_priority": "Prioridad alta",
      "medium_priority": "Prioridad media",
      "low_priority": "Prioridad baja",
      "priority": "Prioridad",
      "custom": "Personalizado",
      "zoom_not_added": "El usuario aún no ha conectado su cuenta de Zoom.",
      "opt_avail": "Optimizar para la disponibilidad",
      "opt_equal": "Optimizar para una distribución equitativa",
      "team_members": "Seleccionar a los miembros del equipo",
      "team_members_location": "Selecciona personal y asigna ubicación de la conferencia",
      "team_member": "Seleccionar un miembro del equipo",
      "team_member_location": "Selecciona personal y asigna ubicación de la conferencia",
      "meeting_location_required": "Se requiere el lugar de la reunión.",
      "meeting_details": "Detalles básicos",
      "meeting_details_description": "Información básica para identificar este calendario.",
      "or_drag_and_drop": "o arrastrar y soltar",
      "service_details": "Detalles del servicio",
      "team_member_disabled_recurring_tooltip": "Las reuniones periódicas solo permiten un miembro del equipo. Para añadir varios miembros del equipo, desactiva las reuniones recurrentes.",
      "team_member_disabled_class_booking_tooltip": "Solo se puede añadir un miembro del equipo a un calendario de reservas de clases.",
      "advanced_settings": "Configuración avanzada",
      "enable_contact_assigned_to_setting": "Para habilitar esta configuración, el formulario debe ser el primero en el orden de los widgets. Reorganiza el orden de los widgets desde la pestaña «Formularios y pago».",
      "reschedule_preference_setting_tooltip": "Seleccionar a quién se debe asignar la cita cuando un {contactLabel} reprograme desde el Widget de reservas.",
      "appointment_preference_tooltip": "Selecciona si las nuevas citas deben reservarse siempre con el usuario asignado al {contactLabel}. Si un {contactLabel} tiene un usuario asignado, se le dará preferencia a ese usuario; de lo contrario, será una asignación rotativa. Consejo: Desactiva la opción «Permitir selección del personal» para evitar que los clientes cambien de miembro del personal en el Widget de reservas.",
      "add_location": "Añadir ubicación",
      "multiple_locations_neo": "Ofrezca múltiples opciones de ubicación para que el cliente pueda elegir. Las ubicaciones múltiples solo son compatibles con el widget Neo.",
      "make_owner": "Hacer propietario",
      "only_one_team_member": "Solo se permite un miembro del equipo cuando se añaden varias ubicaciones.",
      "ask_the_booker_error_message": "La ubicación «Preguntar al cliente» ya existe.",
      "enter_location": "Introduzca un valor de ubicación",
      "enter_display_label": "Introducir la etiqueta de visualización",
      "add_display_label": "Añadir etiqueta de visualización",
      "multiple_location_support_message": "Ofrece múltiples opciones de ubicación para que el cliente elija. Solo el Neo Widget admite múltiples ubicaciones.",
      "only_one_team_member_personal_calendar": "Solo se permite la reserva personal de un miembro del equipo. ",
      "ms_teams_not_added": "El usuario aún no ha conectado su cuenta de Microsoft Teams.",
      "enable_new_appt_preference": "Habilite la nueva preferencia de cita",
      "enable_new_appt_preference_desc": "Al activar «<b>Reservar siempre con el usuario asignado al {contactLabel}</b>» se establecerá automáticamente el <b>formulario</b> como el primer paso en el orden del widget.",
      "location_exists_toast": "Conferencias Ubicación ya añadida",
      "not_supported_with_multiple_team_members": "No se admite con varios miembros del equipo.",
      "not_supported_personal_calendar": "No se admite en el calendario personal",
      "not_supported_class_booking": "No está disponible en el calendario de reservas de clases",
      "not_supported_collective_booking": "No es compatible con el calendario colectivo",
      "not_supported_service_booking": "No compatible con el calendario de servicio",
      "not_supported_round_robin": "No es compatible con el calendario de asignación rotativa",
      "not_supported_event": "No se admite en el calendario de eventos",
      "calendar_logo_tooltip": "Elige un logo para mostrar en el widget de reservas.",
      "calendar_name_tooltip": "Nombre del calendario que se mostrará en el widget de reservas.",
      "description_tooltip": "Describa de qué trata el calendario, que se mostrará en el widget de reservas.",
      "group_tooltip": "Puedes asignar este calendario a un grupo (si está creado). Los usuarios que accedan al enlace del grupo pueden explorar y reservar en todos los calendarios de ese grupo.",
      "custom_url_tooltip": "Personaliza la URL del widget de reserva.",
      "meeting_color_tooltip": "Elegir un color para este evento de reserva. Los colores se sincronizan con los eventos en Google Calendar.",
      "add_display_label_tooltip": "Oculta la ubicación real y muestra una etiqueta personalizada hasta que se reserve la reunión (se aplica cuando se añaden varias ubicaciones).",
      "meeting_location_tooltip": "Selecciona una ubicación o elige 'Personalizado' para añadir cualquier dirección o enlace de reunión.",
      "team_members_location_tooltip": "Seleccione al miembro del personal que llevará esta reunión y establezca su ubicación de reunión.",
      "meeting_distribution": "Distribución de reuniones",
      "meeting_distribution_tooltip": "Elija cómo se asignan las reuniones al equipo.",
      "opt_avail_tooltip": "Asigna las reuniones al miembro del personal disponible en el horario seleccionado, sin tener en cuenta las reservas previas. Maximiza la utilización de franjas horarias disponibles y las tasas de éxito en las reservas.",
      "opt_equal_tooltip": "Distribuya las reuniones de manera equitativa entre todo el personal rastreando las reservas previas. Prioriza la equidad sobre la disponibilidad.",
      "priority_tooltip": "Establece el nivel de preferencia para asignar reuniones cuando haya varios miembros del personal disponibles. El personal con mayor prioridad será considerado primero para las reservas, seguido por el personal con prioridad media y baja.",
      "contact_routing_preference": "Preferencia de enrutamiento de contacto",
      "contact_routing_preference_tooltip": "Defina cómo se asignan los {contactsLabel} nuevos y recurrentes al personal, ya sea de manera rotativa o a su propietario original.",
      "team_members_location_owner_tooltip": "El usuario principal que es propietario de la reunión y proporciona la ubicación final de la conferencia.",
      "owner": "Propietario",
      "upload_from_system": "Subir desde el sistema",
      "choose_from_media_storage": "Seleccionar desde el almacenamiento multimedia",
      "only_one_team_member_allowed": "Solo se permite un miembro del equipo.",
      "at_least_two_team_members_required": "Se necesitan al menos 2 miembros del equipo.",
      "at_least_one_team_member_required": "Se requiere al menos un miembro del equipo.",
      "widget_shape": "Forma del widget:",
      "widget_bookings_path": "/widget/reservas/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "profile-photo",
      "meeting_location_placeholder": "Lugar de la reunión",
      "team_member_meeting_location": "Personal & ubicación de la reunión",
      "meeting_location_desc": "Asigna personal a este calendario y establece dónde se llevarán a cabo las reuniones.",
      "event_calendar_meeting_location_desc": "Elige dónde se llevará a cabo la reunión."
    },
    "meeting_location": {
      "ask_the_booker": "Pregunte al Booker (Booker introduce la ubicación)",
      "ask_the_booker_desc": "Al hacer la reserva, se pide al reservante que introduzca una ubicación de reunión de su elección",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Teléfono",
      "full_address": "Dirección completa",
      "custom": "Personalizado",
      "meeting_location": "Lugar de la reunión"
    },
    "availability": {
      "my_availability": "Mi disponibilidad",
      "calendar_availability": "Disponibilidad de calendario",
      "calendar_availability_desc": "Establece en este calendario cuándo se pueden reservar las reuniones.",
      "set_availability": "Establece aquí tu disponibilidad para el calendario.",
      "standard": "Estándar",
      "custom": "Personalizado",
      "to": "A",
      "copy_to_all": "Copiar a todos",
      "add_time": "Añadir hora",
      "recurring_meeting": "Reunión recurrente",
      "recurring_info": "Solo un usuario por calendario para reservas recurrentes.",
      "repeat": "Repetir",
      "times_to_repeat": "Veces a repetir",
      "slots_unavailable": "¿Si no hay franjas horarias disponibles?",
      "overlap_status": "Estado de la cita para franjas horarias superpuestas ",
      "meeting_interval": "Intervalo de reunión",
      "meeting_duration": "Duración de la reunión",
      "minimum_scheduling": "Aviso mínimo de programación",
      "date_range": "Intervalo de fechas",
      "count_available_days_only": "Contar solo los días disponibles",
      "count_available_days_only_tooltip": "Omite los días sin disponibilidad configurada. Por ejemplo, si usted está cerrado los fines de semana, un rango de 2 días el viernes se extenderá para incluir el lunes y el martes.",
      "maximum_bookings_per_day": "Reservas máximas por día",
      "maximum_bookings_per_slot": "Máximo de reservas por franja horaria",
      "maximum_bookings_per_slot_per_user": "Máximo de reservas por franja horaria (por usuario)",
      "seats_per_class": "Plazas por clase",
      "pre_buffer_time": "Margen de preparación",
      "post_buffer_time": "Margen posterior",
      "pre_buffer_tooltip": "El margen de preparación es un tiempo que puede añadirse antes de una cita a fin de disponer de más tiempo para prepararse.",
      "post_buffer_tooltip": "Margen posterior es un tiempo adicional que puede añadirse después de una cita, permitiendo un tiempo extra para concluirla.",
      "buffer_time": "Margen",
      "daily": "Diario",
      "weekly": "Semanal",
      "monthly": "Mensual",
      "skip_booking": "Omitir la reserva de franjas horarias no disponibles",
      "continue_booking": "Continuar con la reserva",
      "book_next_available": "Reservar la próxima franja horaria disponible",
      "confirmed": "Confirmada",
      "unconfirmed": "Sin confirmar",
      "enter_valid_hours": "Introduce un horario de apertura válido",
      "enter_valid_avail": "Introduce una disponibilidad personalizada válida",
      "availability_type_tooltip": "Selecciona la disponibilidad estándar para las reservas regulares que se ofrecen semanalmente. Selecciona «Personalizado» para las reservas que solo están disponibles en fechas específicas.",
      "meeting_interval_tooltip": "Controla la frecuencia con la que se muestran las franjas horarias de reserva.\nPara una reunión de 30 minutos: \n• Elija 1 hora para mostrar las franjas horarias al inicio de cada hora. \n• Selecciona 30 minutos para que las franjas horarias se muestren cada 30 minutos.",
      "date_range_tooltip": "Los eventos se pueden programar durante los próximos n días.",
      "maximum_bookings_per_day_tooltip": "Número máximo de reuniones permitidas por día en este calendario.",
      "maximum_bookings_per_slot_tooltip": "Limite cuántas reuniones puede recibir un usuario en la misma franja horaria. Si se alcanza el límite, la reserva se asigna al siguiente usuario en la cola de turnos rotativos o la franja horaria se vuelve no disponible.",
      "add_days": "Añadir días",
      "month_on_day": "Mensualmente en el día",
      "month_on_last_day": "Mensualmente el último día",
      "day": "Día",
      "week": "Semana",
      "month": "Mes",
      "mins": "Minutos",
      "hours": "Horas",
      "days": "Días",
      "weeks": "Semanas",
      "months": "Meses",
      "meeting_interval_error": "El intervalo de reunión debe ser de entre 5 minutos y 12 horas.",
      "meeting_duration_error": "La duración de la reunión debe ser de entre 1 minuto y 12 horas.",
      "buffer_time_error": "El margen debe ser inferior a 12 horas.",
      "appointment_interval": "Intervalo de la cita",
      "appointment_duration": "Duración de la cita",
      "maximum_appointments_per_day": "Máximo de citas por día",
      "subTitle": "Elegir la fecha para establecer un horario específico.",
      "heading_1": "Horas disponibles semanales",
      "scheduling_availability_heading": "Disponibilidad de reservas",
      "scheduling_availability_tooltip": "Utiliza una programación de disponibilidad existente o crea uno personalizado para este calendario.",
      "tooltip_1": "Establezca su calendario de disponibilidad semanal. Estas son las horas estándar que se aplicarán semanalmente de forma sistemática.",
      "heading_2": "¿Cuándo estás disponible?",
      "unavailable_label": "No disponible",
      "tooltip_2": "Ajusta tu horario para fechas específicas. Anula las horas semanales regulares marcando tu disponibilidad, o la falta de ella, para las fechas seleccionadas.",
      "date_specific_level": "Añadir horas específicas para una fecha",
      "specific_hours_button": "Horarios específicos por fecha",
      "specific_hours_description": "Establece una disponibilidad personalizada para fechas específicas que difieran de tu programación semanal.",
      "overlap_error": "Las franjas horarias no pueden solaparse",
      "apply": "Aplicar",
      "copy_times_to": "Copiar horas a",
      "no_date_specific_heading": "No se ha añadido una hora específica.",
      "no_date_specific_description": "Puedes añadir o eliminar fechas y horas específicas a tu disponibilidad.",
      "recurring_disabled_conditions_tooltip": "Las reuniones recurrentes están deshabilitadas. Para activarlos, asegúrate de que el calendario tenga solo un Grupo de miembros y no tenga añadido el pago de horas O Incompleto para una fecha específica.",
      "date_specific_hours_disabled_conditions_tooltip": "Para incluir una hora específica en una fecha, asegúrate de que las reuniones recurrentes estén desactivadas.",
      "recurring_disable_event_calendar_conditions": "Las reuniones recurrentes están deshabilitadas. Al Activador, asegúrate de que no se haya añadido ningún pago O Incompleto de horas específicas para una fecha.",
      "service_duration": "Duración del servicio",
      "service_interval": "Intervalo del servicio",
      "service_interval_tooltip": "El intervalo de reunión establece la frecuencia con la que aparecen las franjas horarias de reserva en el calendario. Por ejemplo, para un evento de 30 minutos, un intervalo de 1 hora significa que las franjas horarias aparecen cada hora. Un intervalo de 30 minutos significa que las franjas horarias aparecen cada 30 minutos.",
      "service_duration_tooltip": "Esto determina la extensión de la cita, es decir, el tiempo que durará.",
      "minimum_scheduling_tooltip": "Esto establece el tiempo mínimo requerido para reservar una cita a través del widget de calendario. Por ejemplo, si se establece en 4 horas, las citas no se pueden reservar dentro de las 4 horas anteriores a su hora de inicio, es decir, las reservas deben hacerse con al menos 4 horas de antelación.",
      "look_busy_title": "Muéstrate ocupado",
      "look_busy_helper_text": "Oculta un porcentaje de tus franjas de citas disponibles en el widget de reservas para parecer más ocupado y con mayor demanda.",
      "look_busy_percentage_description": "Ocultar un x % de las franjas horarias disponibles.",
      "maximum_bookings_per_slot_tooltip_personal": "Número máximo de reuniones permitidas en una sola franja horaria.",
      "enable_recurring_title": "Activar reunión recurrente",
      "enable_recurring_desc": "Al activar <b>Reuniones Recurrentes</b>, se deshabilitarán automáticamente las siguientes configuraciones, ya que no pueden coexistir:",
      "date_specific_hours": "Se eliminarán todas <b>horas específicas de una fecha</b>.",
      "multiple_team_members": "Se eliminarán <b>varios miembros del equipo</b>: solo un miembro del equipo puede permanecer en este calendario.",
      "partial_payments": "Se deshabilitarán <b>los pagos incompletos</b> y se cobrará el importe de Completo.",
      "select_team_member_to_keep": "Selecciona un Grupo de miembros para mantener in este calendario:",
      "select_team_member": "Seleccionar un miembro del equipo",
      "partial_payments_disabled": "Dado que los pagos parciales se desactivarán, ¿cómo le gustaría cobrar el importe total de las citas recurrentes?",
      "enable_date_specific_hours": "Habilitar horas específicas de una fecha",
      "enable_date_specific_hours_desc": "Al activar <b>horas específicas de una fecha</b>, se desactivará automáticamente la siguiente configuración, ya que no pueden coexistir:",
      "recurring_meetings_disabled": "<b>Las reuniones recurrentes se desactivarán</b>, {contactsLabel} solo podrán reservar citas individuales en función de las fechas disponibles que establezca.",
      "payment_preference": "Preferencia de pago:",
      "team_members_in_this_calendar": "Miembros del equipo en este calendario",
      "other_team_members": "Otros miembros del equipo (no añadidos a este calendario)",
      "select_team_member_tooltip": "Seleccione al/los miembro(s) del equipo que asistirán a esta reunión.",
      "meeting_duration_tooltip": "Esto establece la duración de su reunión, determinando cuánto tiempo durará.",
      "date_specific_hours_tooltip": "Ajuste su horario para fechas específicas. Anule las horas semanales regulares marcando su disponibilidad, o la falta de ella, para las fechas seleccionadas.",
      "recurring_meeting_tooltip": "Permitir que las reuniones se repitan múltiples veces a lo largo de un período de tiempo.",
      "repeat_frequency_tooltip": "Seleccione la frecuencia de este evento recurrente.",
      "time_to_repeat_tooltip": "Establecer el número total de repeticiones.",
      "slots_unavailable_tooltip": "Elige qué debe suceder si una o más franjas horarias de una reserva recurrente ya están ocupadas.",
      "skip_booking_tooltip": "Solo se reservarán las franjas horarias disponibles. Cualquier fecha no disponible en la serie recurrente será omitida.",
      "force_book": "Libro de fuerza",
      "force_booking_tooltip": "Se reservarán todas las franjas horarias, incluso si hay un conflicto. Utilice con precaución para evitar la doble reserva.",
      "book_next_available_tooltip": "Si una franja horaria seleccionada no está disponible, reserva la siguiente franja horaria disponible en la misma programación recurrente (por ejemplo, el próximo lunes si es semanal).",
      "slot_interval_tooltip": "Establezca el intervalo entre las horas de inicio de las franjas horarias consecutivas disponibles. Por ejemplo, si la duración de su reunión es de 30 min y configura el intervalo en 60 min, un usuario puede reservar a las 9:00 h, luego a las 10:00 h, y así sucesivamente, aunque cada reunión dure solo 30 min.",
      "minimum_scheduling_notice_tooltip": "Requiere que los usuarios reserven reuniones con al menos esta cantidad de tiempo de antelación.",
      "date_range_preferences_tooltip": "Establece hasta cuándo se pueden hacer reservas en el futuro a partir de la fecha actual.",
      "maximum_bookings_per_slot_preferences_tooltip": "Limite cuántas reuniones se pueden programar para la misma franja horaria.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Limita la cantidad de reuniones que se pueden programar en la misma franja horaria (por usuario).",
      "pre_buffer_time_tooltip": "Tiempo para bloquear antes de cada reunión, lo que permite disponer de tiempo adicional para prepararse.",
      "post_buffer_time_tooltip": "Tiempo para bloquear después de cada reunión, lo que permite disponer de tiempo adicional para terminar.",
      "seats_per_class_tooltip": "Establezca el número máximo de participantes que pueden reservar esta clase. Una vez que se llenen todas las plazas, la franja horaria ya no estará disponible para reservar.",
      "maximum_bookings_per_slot_per_user_tooltip": "Limita cuántas reuniones se pueden agendar en la misma franja horaria (por usuario).",
      "repeat_frequency": "Frecuencia de repetición",
      "slot_interval": "Intervalo de franja horaria",
      "skip_booking_helper_text": "Únicamente se reservarán las franjas horarias disponibles. Cualquier fecha no disponible en la serie recurrente será omitida.",
      "force_book_helper_text": "Se reservarán todas las franjas horarias, incluso si hay un conflicto. Utilícelo con precaución para evitar la doble reserva.",
      "book_next_available_helper_text": "Si a Seleccionado Franja horaria no está disponible, Reservar el Siguiente disponible Franja horaria Activado la misma programación recurrente (p. ej., Siguiente Lunes Si Semanal).",
      "bulk_edit": "Edición en bloque",
      "select_users": "Seleccionar usuarios",
      "select_all": "Seleccionar todo",
      "times_to_repeat_tooltip": "Establecer el número total de repeticiones.",
      "custom_recurrence": "Recurrencia personalizada",
      "repeats_every": "Se repite cada",
      "availability_schedule": "Programación de disponibilidad",
      "availability_schedule_desc": "Establece cuándo se pueden reservar reuniones según la disponibilidad del personal.",
      "no_users_added": "¡No se ha añadido personal!",
      "no_users_added_description": "Por favor, añada personal para comprobar su disponibilidad",
      "add_users": "Añadir miembro del personal",
      "minimum_scheduling_notice_error": "Introduzca ≤ 1.440 min.",
      "please_select_date": "Seleccione una fecha para continuar"
    },
    "forms_payment": {
      "forms": "Formularios & invitados",
      "forms_sub": "Configure las preferencias para la página final que aparece después de una reserva exitosa.",
      "select_form": "Seleccionar formulario",
      "enable_same_user_assignment": "Asignar contactos a los respectivos miembros del equipo de calendario cada vez que se reserve una cita.",
      "sticky_contacts_label": "Elemento fijo {contactsLabel}",
      "sticky_contacts": "Prerrellenar los campos",
      "confirmation_page": "Página de confirmación",
      "default": "Por defecto",
      "redirect_url": "Redirigir la URL",
      "use_custom_form_rules": "Utilice reglas de formularios personalizadas",
      "default_message_tooltip": "Muestra el mensaje de confirmación configurado después de que se reserve la cita.",
      "redirect_url_tooltip": "Redirige al cliente a la página configurada después de que se haya reservado la cita.",
      "use_custom_form_rules_tooltip": "Utiliza el mensaje de redirección o el mensaje personalizado definido en el formulario personalizado. Si no se aplica ninguna regla, se mostrará el mensaje de confirmación del calendario.",
      "thank_you": "Mensaje de agradecimiento",
      "enter_url": "Introducir la URL",
      "enter_thank_you_message": "Introduzca el mensaje de agradecimiento.",
      "amount_tab_hidden_label": "Marcador de posición de la pestaña Cantidad",
      "percentage_tab_hidden_label": "Marcador de posición de la pestaña de porcentaje",
      "pixel_id": "Meta Id de píxel (Opcional)",
      "auto_confirm": "Confirmar automáticamente nuevas reuniones del calendario",
      "configure_payment": "Configurar las opciones de pago",
      "accept_payments": "Aceptar pagos",
      "test": "Prueba",
      "live": "En tiempo real",
      "enable_guests": "Añadir invitados",
      "add_guest_tooltip": "La opción de añadir invitados permitirá a tu asistente agregar varios asistentes a la misma cita.",
      "add_guest_custom_form_tooltip": "Al habilitar esta opción, se enviará un correo electrónico generado por el sistema a los invitados con un enlace al formulario personalizado una vez que se confirme su cita. Para evitar correos electrónicos duplicados, asegúrese de que no se haya configurado ya un correo electrónico de confirmación separado para los invitados. (Verifíquelo en la pestaña de Notificaciones > Notificación de Confirmación).",
      "add_guest_same_form_check": "Enviar el mismo formulario para recopilar información por correo a todos los invitados.",
      "payment_tooltip": "El pago solo se consideraría para el asistente principal y no para los invitados.",
      "default_form": "Por defecto (nombre, apellidos, correo electrónico, teléfono, notas)",
      "select_form_tooltip": "Si desea recopilar más información que los datos estándar de Nombre, Apellidos, Correo electrónico y Teléfono de quienes reservan en este calendario, cree un formulario personalizado en Sitios > Formularios > Creador y luego seleccione el formulario en el menú desplegable que aparece a continuación.",
      "confirmation_page_tooltip": "Cuando alguien haga una reserva, puedes elegir entre mostrarle un mensaje personalizado en la misma página (predeterminado) o redirigirlo a la página que elijas (redirigir).",
      "add_guest_collect_email": "Nombre y correo electrónico",
      "add_guest_count_only": "Cuenta únicamente",
      "custom_email_notification": "Enviar un formulario personalizado a los invitados.",
      "consent_label": "Casilla de verificación de consentimiento",
      "consent_input_placeholder": "Añadir texto de consentimiento",
      "same_user_assignment_tooltip": "Para habilitar esta configuración, el formulario debe ser el primero en el widget. Reorganiza el widget para que el formulario aparezca el primero y poder activar esta configuración.",
      "consent_tooltip": "Pida a los contactos que proporcionen su consentimiento al reservar una reunión.",
      "stripe_error": "Hasta dos decimales (ejemplo: 25,99)",
      "auto_confirm_service": "Confirmar automáticamente nuevas citas",
      "service_form_message": "Si un contacto está reservando varios servicios, solo verá el formulario predeterminado en el menú de servicios.",
      "deposit_amount_error": "El importe del depósito debe ser menor que el importe total.",
      "deposit_percentage_error": "El porcentaje del depósito debe ser inferior al 100 %.",
      "partial_payment_tooltip": "Habilita los pagos parciales para cobrar el importe del depósito de los clientes durante el proceso de reserva de la cita.",
      "partial_payment_enable_error": "El importe total introducido debe ser superior a 0 para permitir los pagos parciales.",
      "payment_disable_text_integration": "Integra un proveedor de pagos en Pagos > Integraciones para empezar a aceptar pagos",
      "payment_disable_text_recurring": "La opción de aceptar pagos no está disponible para las reuniones periódicas. Desactiva la periodicidad para habilitar los pagos.",
      "date_and_time_selector": "Selector de fecha y hora",
      "form_selector": "Formulario",
      "order_step": "Paso",
      "widget_order_label": "Orden de los widgets",
      "widget_order_tool_tip": "Reorganiza el orden de «Selector de fecha y hora» y de «Formulario» en el widget de calendario. Basta con arrastrar y reordenar según tus preferencias.",
      "widget_re_order_tooltip": "El reordenamiento solo está disponible con el estilo de widget Neo. Cambiar a Neo para activar la reordenación.",
      "widget_re_order_disabled_tooltip": "Para reordenar el orden del widget, deshabilite la opción «Nueva preferencia de cita (Reservar siempre con el usuario asignado al {contactLabel})» en la sección Detalles de la reunión > Miembros del grupo > Configuración avanzada.",
      "payment_description_error": "Se ha alcanzado el límite máximo de 1000 caracteres.",
      "widget_multiple_location_disabled_tooltip": "El widget clásico no admite varias ubicaciones de reunión. Elimina cualquier ubicación adicional para usar el widget clásico.",
      "recurring_payment_label": "Pago de citas recurrentes",
      "enable_payments_for_guests": "Habilitar pagos para invitados",
      "guest_payment_description": "Puesto que has habilitado la opción «Invitados de Añadir», Tú también puedes seleccionar el cargo por Invitado al hacer la reserva.",
      "charge_per_attendee": "Tarifa por asistente",
      "charge_per_attendee_description": "Multiplicar el importe Total por el número de asistentes (incluidos los invitados) al cobrar el pago durante la reserva.",
      "click_confirm_description": "Haga clic en «Guardar» para aplicar estos cambios.",
      "multiply_amount_guests": "Recoger el pago de cada asistente",
      "multiply_amount_guests_description": "Cuando esté habilitado, el importe a cobrar durante la reserva se multiplicará por el número total de asistentes, incluidos los invitados.",
      "first_appointment_only": "carga solo para el primer Cita",
      "all_appointments": "carga para cada Cita por adelantado",
      "no_payment_provider_connected": "No hay ningún proveedor de pagos conectado.",
      "no_default_payment_provider": "No hay pago Proveedor conectado",
      "provider_not_supported": "No se admite el pago por defecto del proveedor",
      "manage_payment_provider": "Gestiona proveedores de pago",
      "supported_providers": "Proveedores compatibles",
      "paypal_razorpay_helper_text": "Los pagos se procesarán únicamente vía Razorpay, ya que PayPal no es compatible con los proveedores personalizados.",
      "rearrange_widget_order": "Reorganiza el orden de los widgets",
      "change_form_order": "Dinámico el Formulario al segundo Paso in el Widget Ordenar se Deshabilitará el A la zaga/retrasado Ajuste:",
      "change_form_order_desc": "Se deshabilitará la <b>Nueva preferencia de cita (Reservar siempre con el usuario asignado al {contactLabel})</b> Esto significa que las citas se pueden reservar con cualquier miembro del grupo disponible, en lugar de estar restringido al usuario asignado al {contactLabel}.",
      "enable_mandatory_guest": "Crear añadiendo al menos un Invitado Obligatorio. Los campos de invitación se preabrirán y deben completarse antes de la reserva.",
      "enable_mandatory_guest_count": "Realiza el conteo obligatorio de invitados en el widget de reservas.",
      "require_guest_for_booking": "Requiere invitados para la reserva",
      "sticky_contacts_tooltip": "Rellene automáticamente los campos para {contactsLabel} conocidos.",
      "auto_confirm_tooltip": "Marcar automáticamente las nuevas reuniones como confirmadas sin requerir aprobación manual. Desactiva esta opción si deseas revisar y confirmar manualmente cada reserva antes de que se programe.",
      "confirm_tooltip": "Cuando alguien haga una reserva, puedes elegir mostrarle un mensaje personalizado en la misma página (predeterminado) o redirigirlo a la página que elijas (redirigir).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Habilitar la colección de pagos durante las reservas.",
      "total_amount_tooltip": "Establezca el costo total de la reunión.",
      "deposit_amount_tooltip": "Cantidad a cobrar al reservar como depósito.",
      "multiply_amount_guests_all_guests": "Recoge el pago de cada asistente, incluidos los invitados",
      "multiply_amount_guests_all_guests_tooltip": "Cuando esté habilitado, el importe a cobrar durante la reserva se multiplicará por el número total de asistentes, incluidos los invitados.",
      "payment_description": "Descripción del pago",
      "payment_description_desc": "Se muestra al cliente al introducir los detalles del pago.",
      "payment_description_tooltip": "Opcionalmente, incluye cualquier detalle útil sobre el pago.",
      "test_mode_warning": "Modo de prueba Dinámico – no se procesarán Ventas reales.",
      "pixel_id_tooltip": "Envía la actividad del widget de reservas, como vistas, clics y envíos, a Meta usando tu ID de Pixel.",
      "forms_description": "Establezca sus preferencias y configuraciones para recopilar información del cliente durante las reservas.",
      "payment_mode": "Modo de pago",
      "payment_mode_tooltip": "Alterna entre el Modo de prueba y el modo En directo para los pagos. in el Modo de prueba, no se hace ninguna facturación real — Úsala para simular la reserva y el pago Secuencia. Cambiar al modo En directo para aceptar los pagos reales De Clientes.",
      "enable_coupon": "Habilitar códigos de cupón",
      "enable_coupon_tooltip": "Permite a los clientes aplicar códigos de cupón durante la reserva. Para asegurarse de que funcionen, primero cree cupones válidos en Pagos > Códigos de cupón.",
      "guests": "Invitados"
    },
    "notifications": {
      "third_party_cal": "Configuración de calendarios de terceros",
      "third_party_cal_desc": "Configure sus preferencias para los calendarios de terceros.",
      "additional_settings": "Configuraciones adicionales",
      "additional_settings_desc": "Configura opciones adicionales para tu calendario.",
      "notifications": "Notificaciones",
      "notifications_sub": "Configura cómo enviar notificaciones de reserva por correo electrónico, SMS, WhatsApp y alertas en la aplicación.",
      "edit": "Editar",
      "created_on": "Fecha de creación",
      "updated_on": "Actualizado el",
      "delivered": "Entregado",
      "not_available": "N/A",
      "select_notification_type": "Selecciona el tipo de notificación.",
      "notification_person": "¿Quién debería recibir esta notificación?",
      "contact": "{contactLabel}",
      "guest": "Invitado",
      "assigned_user": "Usuario asignado",
      "emails": "Correos electrónicos",
      "alert_email_address": "Dirección de correo electrónico de alerta",
      "ack_email": "Correo electrónico de acuse de recibo",
      "send_google_invites": "Permitir que Google Calendar envíe correos electrónicos de invitación o actualización a los asistentes.",
      "assign_user_to_contact_desc": "Cuando esté activado, el usuario asignado a {contactLabel}coincidirá con el propietario de la cita con el cambio más reciente, ya sea que se haya reservado, reprogramado o reasignado.",
      "send_google_outlook_invites": "Permitir que el calendario de Google/Outlook/iCloud envíe correos electrónicos de invitación & de actualización a los asistentes.",
      "assign_user_to_contact": "Asignar {contactsLabel} a los miembros respectivos del equipo de calendario cada vez que se reserve una cita.",
      "skip_assigning_user_to_contact": "Omitir la asignación de {contactLabel} si el {contactLabel} ya tiene un usuario asignado.",
      "skip_assigning_user_to_contact_desc": "Cuando está activado, el usuario asignado de {contactLabel}permanecerá igual, incluso si el propietario de la cita es diferente.",
      "assigned_staff": "Personal asignado",
      "additional_emails": "Correos electrónicos adicionales",
      "assign_user_to_staff": "Asigne siempre el contacto al propietario de la cita.",
      "allow_cancellation": " Permitir la cancelación de la reunión",
      "allow_reschedule": "Permitir reprogramar la reunión",
      "allow_cancellation_tooltip": "Cuando esta opción esté habilitada, se añadirá un enlace de cancelación a la sección de notas adicionales y se incluirá en la invitación del calendario. Este enlace caducará según lo configurado antes de la hora de inicio de la reunión, lo que evitará que quien haya hecho la reserva pueda cancelar la reunión.",
      "allow_reschedule_tooltip": " Cuando esté habilitado, se añadirá un enlace de reprogramación a la sección de notas adicionales y se incluirá en la invitación del calendario. Este enlace caducará tal como se configuró antes de la hora de inicio de la reunión, lo que impedirá que la persona que hizo la reserva la reprograme.",
      "cancellation_link_expiry": "El enlace de cancelación caducará",
      "reschedule_link_expiry": "El enlace de reprogramación caducará",
      "before_meeting": "antes de la reunión",
      "cancellation_and_reschedule_policy": "Política de cancelación y reprogramación:",
      "meeting_invite_notes": "Notas de invitación a la reunión",
      "meeting_invite_notes_tooltip": "Añada notas que aparecerán en la invitación del calendario enviada a los clientes. Estas notas se sincronizarán con los calendarios de terceros en la descripción de la reunión."
    },
    "connections": {
      "connections_heading": "Sincronización de calendario externo",
      "booking_channels_heading": "Canales de reserva",
      "booking_channels_description": "Configura cómo este calendario recibe reservas de plataformas externas.",
      "connections_sub": "Sincroniza las reuniones con calendarios externos y gestiona cómo se manejan los eventos.",
      "link_to_calendar": "Enlace al calendario",
      "sync_option": "Opción de sincronización",
      "execute_automation": "Ejecutar la automatización",
      "fire_workflow": "Desencadenar disparadores de flujo de trabajo para eventos reservados mediante la sincronización bidireccional.",
      "reserve_with_google": "Reservar con Google [Obsoleto]",
      "reserve_with_google_setup": "Ver instrucciones de configuración",
      "reserve_with_google_configure": "Configurar",
      "change": "Cambiar",
      "rwg_deprecation_notice": "Google ha dejado de usar <b>Reservar con Google (Local Services Ads)</b>. Las nuevas conexiones o los cambios en las conexiones existentes ya no son admitidos. Para seguir recibiendo reservas de Google, utiliza <b>Google Organic Booking</b> en su lugar.",
      "rwg_category": "Categoría",
      "rwg_service_type": "Servicio",
      "connect_lsa": "Conéctate con tu cuenta de Local Service Ads.",
      "reserve_error": "Actualmente, la opción de reservar a través de Google solo está disponible para los nichos de empresa \"Servicios a domicilio», «Servicios inmobiliarios» y «Servicios jurídicos» (proveedores de servicios locales) en Estados Unidos.",
      "one_way": "Unidireccional",
      "two_way": "Bidireccional",
      "smart": "Inteligente",
      "confirm_remove": "¿Estás seguro de que deseas eliminar el calendario de Google?",
      "read_only_access": "No tienes acceso de escritura a este calendario. Selecciona otro calendario.",
      "reserve_with_google_desc": "Este servicio de calendario aparecerá en la reserva de Google únicamente cuando la integración sea satisfactoria.",
      "check_integration": "Comprueba el estado de tu integración",
      "setup_external": "Configura el calendario externo",
      "reserve_price_decimal_error": "No se admiten los decimales en el precio.",
      "reserve_price_max_error": "El precio admitido ha de ser inferior a 1000.",
      "link_to_calendar_tooltip": "Selecciona el calendario externo para sincronizar las reuniones. Los calendarios de Google conectados en la configuración de Calendario → Conexiones están disponibles para seleccionar.",
      "one_way_sync": "Unidireccional",
      "default_one_way": "Sincronización por defecto (sincronización unidireccional)",
      "one_way_sync_desc": "Los sucesos/incidentes/repeticiones del calendario vinculado se sincronizan como franjas bloqueadas, y no se crean contactos para los invitados.",
      "two_way_sync": "Sincronización bidireccional",
      "two_way_sync_desc": "Se crean contactos para los invitados que se encuentran en los eventos del calendario enlazado y estos eventos se convierten en citas del sistema.",
      "smart_sync": "Sincronización inteligente",
      "smart_sync_desc": "Los sucesos/incidentes/repeticiones del calendario vinculado se sincronizan como citas para los contactos actuales. Si no existe ningún contacto, la sincronización se lleva a cabo en franjas horarias bloqueadas sin crear un nuevo contacto.",
      "sync_option_tooltip": "Elija cómo se gestionan los eventos del calendario externo:\n• Unidireccional: Bloquea tiempo en este calendario sin crear {contactsLabel}\n• Bidireccional: Crea reuniones y {contactsLabel} a partir de eventos del calendario externo\n• Inteligente: Crea reuniones solo para los {contactsLabel} existentes y bloquea tiempo para los demás.",
      "default_sync": "Por defecto",
      "default_sync_desc": "Sincroniza eventos de su calendario externo a este calendario.",
      "advanced_sync": "Avanzado",
      "advanced_sync_desc": "Sincroniza eventos de su calendario externo con este calendario y crea contactos y citas en el sistema.",
      "assign_contact_to": "Asignar contacto a",
      "select_calendar": "Seleccionar calendario",
      "sync_preferences": "Preferencias de sincronización",
      "sync_preferences_desc": "¿Cómo le gustaría que se hiciera la sincronización de los sucesos/incidentes/repeticiones de su calendario vinculado?",
      "recommended": "Recomendado",
      "execute_automation_desc": "Ejecutar automatización cuando se crea una conferencia en este calendario.",
      "save": "Guardar cambios",
      "cancel": "Cancelar",
      "reserve_with_google_title": "Reservar con Google",
      "current_connection": "Conexión activa actualmente :",
      "category": "Categoría",
      "service": "Tipo de servicio",
      "price": "Precio estimado",
      "currency": "Moneda"
    },
    "booking_rules": {
      "booking_rules": "Reglas de reserva",
      "booking_rules_description": "Controle cómo y cuándo se pueden agendar reuniones."
    },
    "payments": {
      "payments": "Pagos",
      "payments_description": " Habilitar y gestionar los modelos de pagos, normas y cargos."
    },
    "extras": {
      "extras": "Personalizaciones",
      "extras_sub": "Establece el estilo del widget y otras preferencias.",
      "calendar_widget_style": "Estilo del widget de calendario",
      "neo": "Nuevo",
      "classic": "Clásico",
      "insert_custom_code": "Insertar código personalizado",
      "show_seats_per_slot": "Mostrar plazas por franja horaria",
      "allow_reschedule_meeting": "Permitir reprogramar la reunión",
      "allow_cancelling_meeting": "Permitir cancelar la reunión",
      "additional_notes": "Notas adicionales",
      "cancellation_and_reschedule": "Cancelación y reprogramación:",
      "allow_staff": "Permitir la selección de personal durante la reserva",
      "code_block_tooltip": "Las secuencias de código de terceros dentro del bloque HTML pueden proporcionar una funcionalidad potente, pero también conllevan riesgos para la privacidad, la seguridad, el rendimiento y el comportamiento de la página. Así pues, te recomendamos que revises el contenido de las secuencias antes de guardarlas en el calendario.",
      "calendar_image": "Imagen de portada del calendario",
      "remove_image": "Eliminar imagen",
      "calendar_image_info": "La imagen cargada será visible dentro de la plantilla «Vista de grupo para Neo» y no aparecerá en el enlace del calendario individual.",
      "get_image_from_unsplash": "Mejora tus visuales con",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Configura preferencias adicionales",
      "service_image": "Imagen de portada del servicio",
      "service_image_description": "Selecciona una imagen que se mostrará en el menú de servicios para este servicio.",
      "allow_reschedule_appointment": "Permitir reprogramar la cita",
      "allow_cancelling_appointment": "Permitir cancelar la cita",
      "custom_code_placeholder": "Introduce aquí el código personalizado",
      "calendar_widget_style_desc": "Elige entre nuestro widget clásico o el elegante widget Neo.",
      "seats_per_slot": "Plazas por franja horaria",
      "show_staff_selection": "Selección del personal",
      "seats_per_slot_desc": " Permitir a los usuarios ver el número de plazas disponibles para cada franja horaria directamente en el widget de calendario.",
      "show_staff_selection_desc": "Permitir que los clientes elijan a un miembro del personal directamente desde el widget de calendario durante la reserva de citas. Solo funciona con el widget Neo.",
      "widget_re_order_tooltip": "El estilo de widget clásico no permite cambios en el orden de los widgets. Asegúrate de que el selector de fecha y hora se muestre primero y que el formulario esté en segundo lugar antes de seleccionar el estilo clásico.",
      "show_staff_selection_desc_service": "Permitir que los clientes elijan a un miembro del personal directamente desde el widget de calendario durante la reserva de citas.",
      "switch_to_classic_widget": "Cambia al widget clásico",
      "switch_to_classic_widget_desc": "Cambiar al <b>widget clásico</b> desactivará automáticamente los siguientes ajustes, ya que no pueden coexistir:",
      "form_first_disabled": "<b>El formulario se moverá al segundo paso</b> in Widget ordenar.",
      "appointment_preference_disabled": "<b>Se deshabilitará la nueva preferencia de cita (Reservar siempre con el usuario asignado al {contactLabel})</b>. Esto significa que las citas se pueden reservar con cualquier miembro del grupo disponible, en lugar de estar restringido al usuario asignado al {contactLabel}.",
      "multiple_location_disabled": "Se eliminarán <b>las múltiples conferencias Dirección</b> y solo se mantendrá la <b>Ubicación añadida en primer lugar</b> .",
      "insert_custom_code_tooltip": "Personaliza el estilo del widget usando tu propio código CSS.",
      "classic_tooltip_disabled": "El widget clásico no es compatible con los calendarios de reserva de clases.",
      "show_staff_selection_disabled_tooltip": "La selección de personal solo es compatible con el widget neo."
    },
    "roomsAndEquipments": {
      "title": "Selecciona salas y equipamiento",
      "description": "Selecciona de una lista de salas y equipamiento lo que se reservará junto con este calendario.",
      "rooms": "Seleccionar salas",
      "equipments": "Selecciona el equipo"
    }
  },
  "activity_log": {
    "activity_log": "Registro de actividad",
    "date": "Fecha",
    "filter_by": "Filtrar por",
    "calendar_update": "Actualización del calendario",
    "start_time_update": "Actualización de la hora de inicio",
    "end_time_update": "Actualización de la hora de finalización",
    "title_update": "Actualización de título",
    "notes_update": "Actualización de notas",
    "appointment_status_update": "Actualización del estado de la cita",
    "meeting_location_update": "Actualización de la ubicación de la reunión",
    "google_sync_update": "Actualización de sincronización de Google",
    "outlook_sync_update": "Actualización de sincronización de Outlook",
    "assigned_user_update": "Actualización del usuario asignado",
    "appointment_status": "Estado de la cita",
    "assigned_user": "Usuario asignado",
    "uploaded_to": "Subido a",
    "cancelled": "Cancelada",
    "edited": "editado",
    "other_edits": "Otras ediciones",
    "view_details": "Ver detalles",
    "all": "Todo"
  },
  "appointment_list": {
    "group_all": "TODO",
    "group_primary": "PRINCIPAL",
    "group_user": "USUARIOS",
    "group_team": "GRUPOS",
    "group_calendar": "CALENDARIOS",
    "all_appointments": "Todas las citas",
    "my_calendar": "Mi calendario",
    "status_all": "Todo",
    "status_confirmed": "Confirmada",
    "status_new": "Nueva (acción requerida)",
    "status_show": "Asistido",
    "status_no_show": "No se presentó",
    "status_cancelled": "Cancelada",
    "status_invalid": "No válida",
    "filter_date_added_desc": "Fecha de adición (desc.)",
    "filter_start_added_desc": "Fecha de inicio (Desc)",
    "filter_start_added_asc": "Fecha de inicio en orden ascendente desde hoy",
    "button_new_appointment": "Nueva cita",
    "name": "Nombre",
    "title": "Título",
    "requested_time": "Hora solicitada",
    "date_added": "Fecha de creación",
    "calendar": "Calendario",
    "appointment_owner": "Propietario de la cita",
    "notes": "Notas",
    "status": "Estado",
    "action_view_detail": "Ver detalles",
    "action_view_consent": "Ver consentimiento",
    "action_view_notes": "Ver las notas",
    "action_edit": "Editar",
    "action_delete": "Borrar",
    "action_reschedule": "Reprogramar",
    "page_previous": "Anterior",
    "page_next": "Siguiente",
    "appointment_notes": "Notas de la cita",
    "close": "Cerrar",
    "confirm_delete_header": "Eliminar cita",
    "confirm_delete_message": "¿Estás seguro de que deseas eliminar esta cita? Esta acción no se puede deshacer.",
    "confirm_delete_button": "Borrar",
    "confirm_update_header": "Actualizar el estado de la cita",
    "confirm_update_confirmed_message": "¿Estás seguro de que deseas marcar esta cita como confirmada?",
    "confirm_update_invalid_message": "¿Estás seguro de que deseas marcar esta cita como no válida?",
    "confirm_update_showed_message": "¿Estás seguro de que deseas marcar esta cita como mostrada?",
    "confirm_update_noshow_message": "¿Estás seguro de que deseas marcar esta cita como no presentado?",
    "confirm_update_cancelled_message": "¿Estás seguro de que deseas marcar esta cita como cancelada?",
    "confirm_update_button": "Actualizar",
    "empty_state_title": "No se han encontrado citas",
    "empty_state_description": "No se han encontrado citas.",
    "disable_menu_warning": "No tiene permiso para ver ni editar los detalles de la cita porque el contacto asociado no se le ha asignado. Póngase en contacto con su administrador para obtener asistencia.",
    "no_contact_warning": "No puedes acceder a la información de contacto en este momento. Esto puede deberse a que el contacto no se te ha asignado. Ponte en contacto con el administrador para obtener ayuda.",
    "consent_label": "Consentir",
    "ip_address": "IP",
    "youre_viewing_in": "Actualmente, se está viendo en",
    "appointment_delete_msg": "<b>Nota:</b> La cita eliminada de aquí no se eliminará de Calendly.",
    "rescheduled": "Reprogramado"
  },
  "add_guest": {
    "guest_label": "Invitados",
    "search_placeholder": "Buscar en los contactos",
    "add_new": "Añadir nuevo",
    "save": "Guardar",
    "close": "Cerrar",
    "name": "Nombre",
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "guest_label_count": "Recuento de invitados",
    "guest_count_error": "El número de invitados debe estar entre 1 y 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Detalles del menú de servicios",
    "select_groups_header": "Seleccionar servicios",
    "arrange_groups_header": "Organiza tus servicios",
    "new_service_menu": "Nuevo menú de servicios",
    "service_menu_sub_title": "Crea un menú de servicios personalizado para tus clientes en unos pocos clics",
    "quick_tip": "Puedes añadir grupos al menú de servicios",
    "service_menu_name": "Nombre del menú de servicios",
    "service_menu_description": "Descripción",
    "service_menu_slug": "URL del servicio",
    "select_groups_calendars": "Seleccionar grupos y calendarios",
    "select_groups_calendars_desc": "Añade servicios a tu menú de servicios",
    "select_all": "Seleccionar todo",
    "arrange_groups": "Organizar el orden de los servicios",
    "arrange_groups_desc": "Determina la secuencia de servicios en el menú de servicios",
    "arrange_services_quicktip": "Para reorganizar los calendarios dentro del grupo, ve a Grupos > Opciones > Reorganizar calendarios.",
    "enable_add_guest_desc": "Permite a los clientes incluir invitados adicionales al hacer una reserva.",
    "enable_multiple_service_desc": "Permite a los clientes reservar múltiples servicios en una sola cita.",
    "enable_staff_selection_desc": "Permite a los clientes seleccionar a los miembros del personal preferidos al hacer una reserva.",
    "enable_add_guest": "Habilitar «Añadir invitados»",
    "enable_multiple_service": "Habilitar la selección de múltiples servicios",
    "enable_staff_selection": "Habilitar la selección del personal",
    "additional_options": "Opciones adicionales",
    "code_block_tooltip": "Las secuencias de código de terceros dentro del bloque HTML pueden proporcionar una funcionalidad potente, pero también conllevan riesgos para la privacidad, la seguridad, el rendimiento y el comportamiento de la página. Así pues, te recomendamos que revises el contenido de las secuencias antes de guardarlas en el menú de servicios.",
    "custom_code_placeholder": "Introduce aquí el código personalizado",
    "insert_custom_code": "Insertar código personalizado",
    "no_service": "No se ha encontrado ningún servicio",
    "no_service_desc": " No se han encontrado servicios. Crea servicios y añádelos a grupos para crear un menú de servicios.",
    "learn_more": "Más información",
    "no_service_selected": "No se ha seleccionado ningún servicio",
    "create_service_calendars": "Crear calendarios de servicios",
    "alert_description": " Para crear un menú de servicios, necesitas crear calendarios de servicios y añadirlos a los grupos.",
    "dont_show_again": "No volver a mostrar",
    "service_name_required": "El nombre del menú de servicios es obligatorio",
    "slug_already_taken": "Este slug ya está tomado",
    "slug_required": "Se requiere un slug",
    "please_enter_name": "Introduce un nombre",
    "service_name_placeholder": "Menú principal",
    "service_slug_placeholder": "menú principal",
    "form_label": "Formulario",
    "consent_label": "Casilla de verificación de consentimiento",
    "consent_input_placeholder": "Añadir texto de consentimiento",
    "consent_tooltip": "Active esta opción para permitir obtener el consentimiento de los {contactsLabel} cuando proporcionen su número de teléfono durante el proceso de reserva de la cita.",
    "back_message": "Volver a la lista",
    "saving_changes": "Solo un minuto — Guardando el último Dinámico...",
    "payment_provider_warning": "¡Atención! Ahora, los menús de servicios solo admiten pagos vía Stripe y Authorize.net. Dado que su proveedor por defecto es diferente, se omitirá el cobro de pagos para los calendarios seleccionados con pagos habilitados.",
    "aria": {
      "consent_form_toggle": "Conmutador del formulario de consentimiento",
      "enable_add_guest_toggle": "Habilitar el conmutador para añadir invitado",
      "enable_multiple_services_toggle": "Habilitar el conmutador de alternancia de múltiples servicios",
      "enable_staff_selection_toggle": "Habilitar el conmutador de selección de personal"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Personalizar el widget de calendario",
    "works_with_neo_widget": "Solo funciona con el widget Neo",
    "customise_widget_desc": "Personaliza la apariencia del widget: color primario, color de fondo y texto del botón.",
    "learn_more": "Más información",
    "primary_settings": "Configuración principal",
    "primary_settings_desc": "Configura el color principal, el color de fondo y otras preferencias del widget para personalizar el widget del calendario.",
    "primary_color": "Color principal",
    "primary_color_desc": "Definir el color de los botones, las fechas, las franjas horarias y las acciones.",
    "background_color": "Color de fondo",
    "background_color_desc": "Establece el color de fondo que sirve como fondo para el selector de fecha y hora y el formulario.",
    "button_text": "Texto del botón",
    "button_text_desc": "Personaliza el texto que se muestra en el botón al reservar una cita.",
    "calendar_title": "Título del calendario",
    "calendar_title_desc": "El nombre de tu calendario",
    "calendar_description": "Descripción del calendario",
    "calendar_description_desc": "La descripción introducida.",
    "calendar_details": "Detalles del calendario",
    "calendar_details_desc": "Incluye información como la duración, la fecha y la hora, los detalles recurrentes y la zona horaria.",
    "reset_to_default": "Restablecer los valores predeterminados",
    "preview_widget": "Vista previa del widget",
    "calendar_title_tooltip": "Configura si el nombre del calendario y el nombre del grupo (si corresponde) deben ser visibles en el widget de reservas.",
    "calendar_description_tooltip": "Configura si la descripción del calendario debe ser visible en el widget de reserva.",
    "calendar_details_tooltip": "Colección Si la Clave reuniones Detalles como Conferencias Duración, Seleccionado Fecha & Fecha, y la información de periodicidad (si corresponde) deben ser visibles Activado el Widget de reservas.",
    "insert_custom_code_tooltip": "Personalizar el estilo del Widget Vía tu propio código CSS .",
    "staff_selection_tooltip": "Habilitar reservante para seleccionar un miembro del personal directamente del Widget de calendario durante la reserva de Cita. Solo funciona con el Widget Neo ."
  },
  "eventNotification": {
    "customFields": "Campos personalizados",
    "customValues": "Valores personalizados",
    "templateVariableIssueDefaultPartBefore": "Hay problemas con su ",
    "templateVariableIssueDefaultPartHighlight": "valores personalizados",
    "templateVariableIssueDefaultPartAfter": "; por favor, revíselos y corríjalos antes de guardarlos.",
    "templateVariableInvalidListOverflow": "… y {count} más",
    "templateVariableIssueSingle": "Hay un problema con este valor personalizado: {value}; por favor, corríjalo antes de guardar.",
    "templateVariableIssueEmpty": "Uno o más valores personalizados están vacíos ({emptyPair}); por favor, añada un campo válido dentro de los corchetes.",
    "templateVariableIssueMarkup": "Algunos valores personalizados incluyen HTML o formato, lo cual no es compatible; por favor, elimínelo antes de guardar.",
    "templateVariableSaveFailed": "No se pudo guardar la notificación {receiverLabel}. Por favor, corrija los errores de valores personalizados antes de guardar",
    "templateVariableSaveFailedGeneric": "No se ha podido guardar la notificación. Por favor, corrija los errores de valores personalizados antes de guardar",
    "guest": "Invitado",
    "assignedUser": "Usuario asignado",
    "additionalEmails": "Correos electrónicos adicionales",
    "list": {
      "booked": {
        "title": "Cita reservada (estado: No confirmada)",
        "modalTitle": "cita reservada (estado: No confirmada)",
        "note": "Esta Notificación se envía cuando se envía a Nueva Cita está Creada con Estado no confirmado.",
        "subTitle": "Notifica cuando se reserva una cita con un estado sin confirmar."
      },
      "confirmation": {
        "title": "Cita reservada (estado: Confirmada)",
        "modalTitle": "cita reservada (estado: Confirmada)",
        "note": "Esta Notificación se cuando se envía una Cita se Crea con O Actualizado al Confirmada Estado.",
        "subTitle": "Notifica cuando una cita se confirma correctamente."
      },
      "cancellation": {
        "title": "Cancelación",
        "modalTitle": "cancelación",
        "note": "Esta Notificación se envía cuando se cancela una Cita, se marca como No asistido y se marca como No válida.",
        "subTitle": "Alertas cuando se cancela una cita."
      },
      "reschedule": {
        "title": "Reprogramar",
        "modalTitle": "Reprogramar",
        "note": "Esta notificación se ha enviado cuando se ha reprogramado una Cita. Solo se activará si la Cita está in Estado No confirmado O Confirmada.",
        "subTitle": "Notifica cuando se reprograma una cita."
      },
      "reminder": {
        "title": "Recordatorio",
        "modalTitle": "recordatorio",
        "note": "Esta Notificación se envía como Recordatorio antes de la Cita. Solo se activará si la Cita está in Estado No confirmado O Confirmada.",
        "subTitle": "Envía un recordatorio antes de la cita."
      },
      "followup": {
        "title": "seguimiento",
        "modalTitle": "seguimiento",
        "note": "Esta Notificación se envía después de la Cita como a seguimiento. Solo se activará si la Cita está in No confirmada, Confirmada, O Asistido Estado.",
        "subTitle": "Envía un mensaje de seguimiento después de que se complete la cita."
      }
    },
    "saveToastMsg": "¡Configuración guardada!",
    "saveToastMsgDesc": "Los cambios se han guardado correctamente.",
    "enableSuccess": "¡Notificaciones activadas!",
    "disableSuccess": "¡Notificaciones desactivadas!",
    "tooltip": "Esta Notificación ha sido Deshabilitado. Habilitarlo para crear cualquier Dinámico.",
    "enabled": "Habilitado",
    "disabled": "Deshabilitado",
    "statusLabel": "Etiquetas de estado",
    "email": {
      "channelName": "Correo electrónico",
      "noneTemplate": "Ninguno",
      "notificationLabel": "¿Quién debería recibir esta notificación?",
      "sendButtonLabel": "Enviar correo de prueba",
      "testEmailLabel": "Probar correo electrónico",
      "testEmailPlaceholder": "Introduce la dirección de correo electrónico del destinatario para hacer la comprobación",
      "body": "Cuerpo del correo electrónico",
      "bodyPlaceholder": "Escribe tu mensaje aquí",
      "subject": "Asunto",
      "subjectPlaceholder": "Introduce el asunto del correo electrónico",
      "templateLabel": "Plantilla de correo electrónico",
      "templatePlaceholder": "Selecciona una plantilla de correo electrónico o empieza desde cero",
      "fromNamePlaceholder": "Introduce el nombre",
      "fromNameLabel": "Nombre del remitente",
      "fromAddressLabel": "Desde la dirección",
      "alertEmailAddress": "Introduzca los ID de correo electrónico (separados por comas)",
      "addMore": "Añadir más",
      "afterAppointmentEnds": "una vez termine la cita",
      "beforeAppointmentStarts": "antes de que comience la cita",
      "durationLabel": "¿Cuándo quieres activar la notificación?",
      "disableEmailNotification": "Deshabilitar las notificaciones por correo electrónico",
      "enableEmailNotification": "Habilitar las notificaciones por correo electrónico",
      "enableSuccess": "¡Notificación de correo electrónico activada!",
      "enableSuccessDesc": "A partir de ahora, empezarás a recibir esta notificación",
      "disableSuccess": "¡Notificación por correo electrónico desactivada!",
      "disableSuccessDesc": "Ya no recibirás esta notificación",
      "reset_to_default": "Restablecer a Por defecto",
      "testEmailSuccessTitle": "¡Correo electrónico de prueba enviado!",
      "testEmailSuccessDesc": "El correo electrónico de prueba se ha enviado correctamente a {email}.",
      "testEmailErrorTitle": "No se ha podido enviar el correo electrónico de prueba",
      "testEmailErrorDesc": "Ha habido un error al enviar el correo electrónico de prueba. Vuelva a intentarlo.",
      "create_new_email_template": "Crear nueva plantilla de correo electrónico",
      "templateVariableFieldSubject": "Línea de asunto",
      "templateVariableFieldFromName": "Nombre del remitente",
      "templateVariableFieldFromAddress": "Desde la dirección",
      "templateVariableFieldEmailBody": "Cuerpo del correo electrónico"
    },
    "inApp": {
      "channelName": "inla aplicación",
      "title": "Configuración de notificaciones",
      "enableInAppNotification": "Activar la notificación dentro de la app",
      "disableInAppNotification": "Desactivar notificaciones en la aplicación",
      "selectedUser": {
        "label": "Enviar a",
        "helperText": "Esta notificación interna se envía a través de la web y las aplicaciones móviles.",
        "placeholder": "Seleccionar usuario(s)"
      },
      "enableSuccess": "¡Notificaciones de la aplicación activadas!",
      "enableSuccessDesc": "A partir de ahora, recibirá esta notificación.",
      "disableSuccess": "¡Notificaciones de la aplicación desactivadas!",
      "disableSuccessDesc": "Ya no recibirá esta notificación."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Ninguno",
      "notificationLabel": "¿Quién debería recibir esta notificación?",
      "sendButtonLabel": "Enviar SMS de prueba",
      "testSMSLabel": "SMS de prueba (introduzca el número de teléfono con el código del país)",
      "testSMSPlaceholder": "+12345678901",
      "body": "Mensaje SMS",
      "bodyPlaceholder": "Escriba aquí su mensaje de SMS",
      "durationLabel": "¿Cuándo desea que se active la notificación?",
      "disableSMSNotification": "Deshabilitar las notificaciones por SMS",
      "enableSMSNotification": "Habilitar las notificaciones por SMS",
      "enableSuccess": "¡Notificación por SMS habilitada!",
      "enableSuccessDesc": "A partir de ahora, recibirá esta notificación.",
      "disableSuccess": "Las notificaciones por SMS están deshabilitadas.",
      "disableSuccessDesc": "Ya no recibirá esta notificación.",
      "alertPhoneNumbers": "Introduzca los números de teléfono (con los códigos de país, separados por comas)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Añadir más",
      "afterAppointmentEnds": "una vez completada la cita",
      "beforeAppointmentStarts": "antes de que empiece la cita",
      "templateLabel": "Plantilla de SMS",
      "templatePlaceholder": "Seleccionar plantilla de SMS...",
      "reset_to_default": "Restablecer a los valores por defecto",
      "testSmsSuccessTitle": "¡SMS de prueba enviado!",
      "testSmsSuccessDesc": "El SMS de prueba se ha enviado correctamente a {phone}.",
      "testSmsErrorTitle": "Error al enviar el SMS de prueba",
      "testSmsErrorDesc": "Se ha producido un error al enviar el SMS de prueba. Vuelva a intentarlo.",
      "templateVariableFieldSmsBody": "Cuerpo del mensaje"
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "¿Quién debería recibir esta notificación?",
      "sendButtonLabel": "Enviar notificación de prueba de WhatsApp",
      "testWhatsAppLabel": "Prueba de notificación de WhatsApp (introduzca el número de teléfono con el código del país)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "¿Cuándo desea que se active la notificación?",
      "alertPhoneNumbers": "Introduzca los números de teléfono (con los códigos de país, separados por comas)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Añadir más",
      "afterAppointmentEnds": "una vez completada la cita",
      "beforeAppointmentStarts": "antes de que empiece la cita",
      "templateLabel": "Plantilla de WhatsApp",
      "templatePlaceholder": "Seleccionar la plantilla de WhatsApp...",
      "noPreview": "No se ha seleccionado ninguna plantilla",
      "templateRequired": "Plantilla obligatoria",
      "testWhatsAppSuccessTitle": "¡Notificación de prueba de WhatsApp enviada!",
      "testWhatsAppSuccessDesc": "Se ha enviado correctamente la notificación de prueba de WhatsApp a {phone}.",
      "testWhatsAppErrorTitle": "No se pudo enviar la notificación de prueba de WhatsApp.",
      "testWhatsAppErrorDesc": "Se ha producido un error al enviar la notificación de prueba de WhatsApp. Vuelva a intentarlo.",
      "setupTitle": "Comuníquese con su cliente a través de su aplicación de mensajería favorita.",
      "setupDescription": "Manténgase más cerca de sus clientes proporcionándoles asistencia instantánea, enviándoles actualizaciones a tiempo y creando interacciones atractivas.",
      "connectWhatsApp": "Conectar WhatsApp",
      "checkingStatus": "Comprobando el estado de la cuenta de WhatsApp...",
      "checkingTemplateStatus": "Comprobando el estado de la plantilla de WhatsApp...",
      "statusCheckError": "Error al comprobar el estado de la cuenta de WhatsApp.",
      "templateStatusCheckError": "No se pudo verificar el estado de la plantilla de WhatsApp.",
      "setupTemplateTitle": "Completa la configuración de tu plantilla de WhatsApp.",
      "setupTemplateDescription": "Tú necesitas Configurar las plantillas de WhatsApp Antes de poder Subir notificaciones. Hacer clic debajo para Terminar la Secuencia de Config.",
      "loadTemplatesError": "Error al cargar las plantillas de WhatsApp.",
      "templatesRefreshed": "Plantillas actualizadas correctamente",
      "templatesRefreshError": "Error al actualizar las plantillas.",
      "templatesResolveError": "Error al procesar las plantillas predeterminadas de WhatsApp.",
      "locationNotFound": "ID de ubicación no encontrado.",
      "settingsRedirectError": "No es posible redirigir a los ajustes de WhatsApp.",
      "updateNotificationError": "Error al actualizar la notificación de WhatsApp.",
      "notificationsEnabled": "¡Notificaciones de WhatsApp activadas!",
      "notificationsDisabled": "¡Notificaciones de WhatsApp desactivadas!",
      "updateError": "Error al actualizar las notificaciones.",
      "createNewTemplate": "Crear nueva plantilla de WhatsApp",
      "phoneValidation": {
        "countryCodeRequired": "El número de teléfono debe empezar por el código del país (por ejemplo, +1, +91, +44).",
        "digitsOnly": "El número de teléfono debe contener solo dígitos después del código de país.",
        "tooShort": "El número de teléfono es demasiado corto.",
        "tooLong": "El número de teléfono es demasiado largo.",
        "invalid": "Número de teléfono no válido."
      },
      "errors": {
        "templateNotFound": "No se ha encontrado el id. de la plantilla en las opciones cargadas, borrando.",
        "templateNoLongerValid": "La plantilla guardada ya no es válida, borrando.",
        "invalidTemplateSelection": "Se ha intentado seleccionar una plantilla de WhatsApp no válida.",
        "fetchingTemplates": "Error al recuperar las plantillas de WhatsApp.",
        "mountingCreator": "Error al montar el Creador de Plantillas de WhatsApp.",
        "fetchingAfterCreation": "Error al recuperar las plantillas de WhatsApp después de su creación.",
        "updateStatus": "Error al actualizar el estado de WhatsApp."
      },
      "receiverLabels": {
        "assignedUser": "Usuario asignado",
        "phoneNumbers": "Números de teléfono adicionales"
      }
    }
  },
  "smsTemplate": {
    "create_new_template": "Crear nueva plantilla de SMS",
    "create_new_template_desc": "Cree una plantilla reutilizable de SMS para sus notificaciones.",
    "template_name": "Nombre de la plantilla",
    "template_name_placeholder": "Introduzca el nombre de la plantilla",
    "message": "Mensaje",
    "message_placeholder": "Escriba aquí su mensaje de SMS.",
    "create_template": "Crear plantilla",
    "name_required": "El nombre de la plantilla es obligatorio",
    "text_required": "El texto del mensaje es obligatorio",
    "fetch_new_templates": "Actualizar las plantillas",
    "characters": "caracteres",
    "words": "palabras",
    "segments": "segs"
  },
  "whatsappTemplate": {
    "create_new_template": "Crear nueva plantilla de WhatsApp",
    "create_new_template_desc": "Cree una plantilla reutilizable de WhatsApp para sus notificaciones.",
    "template_name": "Nombre de la plantilla",
    "template_name_placeholder": "Introduzca el nombre de la plantilla",
    "message": "Mensaje",
    "message_placeholder": "Escriba aquí el mensaje de WhatsApp.",
    "create_template": "Crear plantilla",
    "name_required": "El nombre de la plantilla es obligatorio",
    "text_required": "El texto del mensaje es obligatorio",
    "fetch_new_templates": "Actualizar las plantillas"
  },
  "archivedServices": {
    "servicesBanner": "Una nueva versión mejorada de los servicios ha llegado: más potente, flexible e intuitiva. Tus calendarios de servicio ya han sido migrados. Explóralos ahora en la pestaña de Servicios.",
    "archivedServiceCalendars": "Calendarios de servicio (v1)",
    "check_new_services": "Verificar nuevos servicios"
  },
  "tour": {
    "hidden_test_label": "Prueba",
    "calendar": {
      "edit_calendar": "Editar calendario",
      "share_calendar": "Compartir calendario",
      "troubleshoot_calendar": "Solucionar problemas del calendario",
      "more_options": "Más opciones",
      "edit_calendar_desc": "Gestionar cada configuración del calendario: fijar la disponibilidad, configurar recordatorio, modificar los límites de citas y mucho más.",
      "share_calendar_desc": "Copiar y Compartir tu Enlace de programación para que Reservante pueda programar fácilmente con Tú.",
      "troubleshoot_calendar_desc": "Averigüe por qué no se muestra una franja horaria y consulte los posibles motivos en la vista de solución de problemas.",
      "more_options_desc": "Acceso adicional Configuración y Actividades para Gestionar tu calendario.",
      "read_permissions": {
        "share_description": "Conceda acceso a otras personas compartiendo el enlace del calendario o ajustando los permisos.",
        "troubleshoot_description": "Identifique y resuelva problemas como errores de sincronización o eventos faltantes para garantizar un funcionamiento fluido."
      },
      "next": "Siguiente",
      "start_over": "Empiece de nuevo",
      "all_set": "¡Todo listo!",
      "previous": "Anterior"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Selecciona tu experiencia de edición",
    "select_editing_experience_desc": "Elija construir usando nuestro Editor Visual de Diseño de Arrastrar y Soltar o el Potente Editor de Código.",
    "design_editor": "Editor de diseño",
    "design_editor_desc": "Edición visual de arrastrar y soltar.",
    "code_editor": "Editor de código",
    "code_editor_desc": "Edición HTML con funcionalidades avanzadas.",
    "text_editor": "Editor de texto sin formato",
    "text_editor_desc": "Edición de texto básica, limpia y sin adornos.",
    "email_text_block": "Correo electrónico también puede ser Creada Vía Cuerpo Bloque. ",
    "select": "Seleccionar",
    "new_template": "Nueva plantilla",
    "email_block": "El correo electrónico también puede crearse usando un bloque de texto.",
    "fetch_new_templates": "Obtén nuevas plantillas"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Utiliza un nombre de reunión y una descripción claros para que los reservadores sepan exactamente lo que están programando.",
      "groups_share_link": "Los grupos permiten compartir un único enlace de programación para varios calendarios, permitiendo a los clientes elegir y reservar entre las opciones disponibles."
    },
    "staff_location": {
      "custom_location": "Selecciona 'Personalizado' como ubicación de la reunión para ingresar cualquier dirección o enlace que prefieras.",
      "ask_booker_location": "Cuando se selecciona Preguntar al reservante, se solicita al reservante que introduzca la ubicación de la reunión durante la reserva",
      "round_robin_priority": "Las configuraciones de prioridad influyen en la distribución de las reuniones cuando hay varios empleados disponibles.",
      "connect_video_integrations": "Conecta las integraciones de videoconferencia desde la configuración del calendario → Conexiones antes de seleccionarlas como la ubicación de la reunión."
    },
    "availability": {
      "staff_availability_required": "Las reuniones solo pueden reservarse cuando al menos un miembro del personal seleccionado esté disponible.",
      "use_precreated_schedule": "Puedes utilizar una programación de disponibilidad pre-creada desde Configuración del calendario → Disponibilidad o crear una programación personalizada solo para este calendario.",
      "timezone_in_schedule": "La zona horaria de las reuniones se configura dentro de la programación de disponibilidad seleccionada.",
      "event_24_hours": "Para que el calendario esté disponible las 24 horas, configure la ventana de tiempo de 00:00 a 00:00."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Las reglas de reserva se aplican a todas las reuniones de este calendario, sin importar la disponibilidad del personal.",
      "minimum_scheduling_notice": "Aumentar el aviso mínimo de programación para evitar reservas de última hora.",
      "maximum_bookings_per_slot": "Utiliza el máximo de reservas por franja horaria para controlar cuántas reuniones pueden tener lugar simultáneamente."
    },
    "forms": {
      "custom_contact_fields": "Puede incluir campos de contacto personalizados tanto en los mensajes de formulario como en las URL de formulario.",
      "create_custom_form": "Para recopilar más información, cree un formulario personalizado desde Sitios → Formularios → Builder y úselo con este calendario."
    },
    "payments": {
      "collected_during_booking": "Los pagos se recogen durante la reserva y deben completarse antes de que se confirme la reunión.",
      "payment_description": "Utilice la descripción del pago para explicar claramente el motivo del cargo."
    },
    "notifications": {
      "review_policies": "Revisa las políticas de cancelación y reprogramación para evitar cambios de última hora.",
      "use_workflows": "Para la automatización avanzada, utilice flujos de trabajo con el activador de cita reservada."
    },
    "customizations": {
      "preview_widget": "Previsualice el widget para asegurarse de que se alinea con su marca y flujo de reservas.",
      "update_widget_language": "Los ajustes de idioma del widget se pueden modificar desde Configuración → Calendarios → Preferencias."
    },
    "connections": {
      "google_organic_booking": "Configurar la Reserva orgánica de Google permite que este calendario reciba reservas directamente desde la búsqueda de Google.",
      "external_sync_event": "Únicamente el calendario seleccionado en Sincronización externa se utiliza para obtener y enviar eventos para este calendario."
    },
    "equipments": {
      "room_definition": "Una «sala» puede designar cualquier lugar donde se presten servicios. Puede tratarse de una sala física o espacios específicos. Por ejemplo: un espacio de pedicura.",
      "equipment_definition": "Por «equipamiento» se entiende cualquier herramienta o dispositivo que utilizan las empresas para cumplir con sus compromisos. Esto puede incluir máquinas, dispositivos o incluso sillas."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Contactos fijos",
    "consent_form": "Formulario de consentimiento",
    "enable_guests": "Habilitar invitados",
    "auto_confirm": "Confirmar automáticamente",
    "should_accept_payment": "Debe aceptar el pago",
    "collect_deposit": "Cobrar depósito",
    "enable_charge_guests": "Habilitar el cobro a invitados",
    "enable_coupon": "Activar cupón",
    "payment_live": "Pago en tiempo real",
    "add_availability_hour": "Añadir hora de disponibilidad",
    "remove_availability_hour": "Eliminar hora de disponibilidad",
    "copy_availability_hour": "Copiar hora de disponibilidad",
    "close_modal": "Cerrar el modal",
    "add_custom_slot": "Añadir franja horaria personalizada",
    "remove_custom_slot": "Eliminar franja horaria personalizada",
    "edit_custom_slot": "Editar franja horaria personalizada",
    "update_frequency": "Frecuencia de actualización",
    "show_calendar_title": "Mostrar el título del calendario",
    "show_calendar_description": "Mostrar descripción del calendario.",
    "show_calendar_details": "Mostrar información del calendario",
    "allow_reschedule": "Permitir la reprogramación",
    "allow_cancellation": "Permitir la cancelación",
    "category_actions": "Acciones de categoría",
    "show_seats_per_slot": "Mostrar plazas por franja horaria",
    "add_more": "Añadir más",
    "same_user_assignment_toggle": "Conmutador de asignación del mismo usuario"
  },
  "placeholders": {
    "pixel_id": "ID de píxel",
    "select_one": "Seleccionar uno",
    "meeting_location": "Lugar de la reunión",
    "schedule_meeting": "Programar reunión",
    "notes": "Notas",
    "select_users": "Seleccionar usuarios",
    "please_select": "Seleccione"
  },
  "alt_text": {
    "payment_provider": "Proveedor de pagos",
    "no_calendars": "No hay calendarios",
    "date_specific_hours": "horas-específicas-por-fecha",
    "custom_widget_image": "Imagen personalizada de widget",
    "service_calendar": "Calendario de servicios",
    "event_calendar": "Calendario de eventos",
    "round_robin_booking": "Reserva rotativa",
    "class_booking": "Reserva de clases",
    "collective_booking": "Reserva colectiva",
    "calendar_cover_image": "Imagen de portada del calendario",
    "email_notification_switch": "Interruptor de notificaciones por correo electrónico",
    "email_template_icon": "Icono de plantilla de correo electrónico",
    "in_app_notification_switch": "Interruptor de notificaciones en la aplicación",
    "sms_notification_switch": "Conmutador de notificaciones por SMS",
    "whatsapp_notification_switch": "Interruptor de notificaciones de WhatsApp",
    "no_service_found": "No se ha encontrado ningún servicio",
    "no_group_found": "No se encontró ningún grupo",
    "sync_icon": "Icono de sincronización",
    "sync_type": "Tipo de sincronización",
    "test1": "prueba1",
    "test2": "prueba2"
  },
  "tooltips": {
    "text_color": "Color del texto",
    "background_color": "Color de fondo",
    "strikethrough": "Tachado",
    "superscript": "Superíndice",
    "subscript": "Subíndice",
    "inline_code_block": "Bloque de código en línea",
    "code_block": "Bloque de código",
    "block_quote": "Bloquear presupuesto",
    "more": "Más",
    "upload": "Subir",
    "image_upload_tooltip": "PNG, JPEG, JPG o GIF (máx. dimensiones 180x180px | máx. tamaño 2,5 MB).",
    "custom_values": "Valores personalizados",
    "text_wrap": "Ajuste de texto",
    "trigger_links": "Enlaces de activación",
    "text_align": "Alineación de texto"
  },
  "labels": {
    "reset_style": "Restablecer estilo",
    "reset_document_style": "Restablecer el estilo del documento",
    "source_code": "Código fuente",
    "success": "Completado",
    "edit": "Editar",
    "submit": "Guardar",
    "cancel": "Cancelar",
    "payment": "Pago",
    "here_is_the_link": "Aquí está enlace:",
    "here_is_the_embed_code": "Aquí está el código de inserción:",
    "service_calendar": "Calendario de servicios",
    "collective_booking": "Reserva colectiva",
    "class_booking": "Reserva de clase",
    "round_robin_booking": "Reserva rotativa",
    "event_calendar": "Calendario de eventos",
    "personal_booking": "Reserva personal",
    "service_booking": "Reserva de servicio",
    "calendar_id": "ID del calendario"
  },
  "validation_messages": {
    "calendar_group_name_required": "El nombre del grupo de calendarios es obligatorio.",
    "calendar_group_description_required": "La descripción del grupo de calendarios es necesaria.",
    "slug_required": "El slug es obligatorio.",
    "slug_not_valid": "Este slug no es válido.",
    "slug_already_taken": "Este slug ya está en uso.",
    "error_validating_slug": "Error al validar el slug.",
    "please_enter_name": "Introduzca un nombre.",
    "room_name_required": "El nombre de la sala es obligatorio",
    "equipment_name_required": "El nombre del equipamiento es obligatorio.",
    "subject_required": "El asunto es obligatorio.",
    "this_is_required": "Esto es necesario.",
    "calendar_group_slug_required": "Se requiere el slug del grupo de calendario.",
    "capacity_mandatory": "La capacidad es obligatoria.",
    "capacity_cannot_be_zero": "La capacidad no puede ser cero.",
    "capacity_should_be_a_number": "La capacidad debería ser un número.",
    "capacity_cannot_be_negative": "La capacidad no puede ser negativa.",
    "capacity_should_be_a_whole_number": "La capacidad debe ser un número entero.",
    "quantity_mandatory": "La cantidad es obligatoria",
    "quantity_cannot_be_zero": "La cantidad no puede ser cero.",
    "quantity_should_be_a_number": "La cantidad debe ser un número.",
    "quantity_cannot_be_negative": "La cantidad no puede ser negativa.",
    "quantity_should_be_a_whole_number": "La cantidad debe ser un número entero.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "La cantidad no puede ser inferior a la de los equipos fuera de servicio.",
    "out_of_service_value_should_be_a_number": "El valor «Fuera de servicio» debe ser un número.",
    "out_of_service_cannot_be_negative": "El estado «Fuera de servicio» no puede ser negativo",
    "out_of_service_equipments_qty": "El número de equipamientos fuera de servicio no puede ser superior al número real de equipamiento.",
    "out_of_service_whole_number": "Fuera de servicio debería ser un número entero.",
    "slot_duration_required": "La duración de la franja horaria es obligatoria.",
    "slot_duration_integer": "La duración de la franja horaria debe ser un número entero.",
    "meeting_duration_validation": "La duración de la reunión debe ser de entre 1 minuto y 12 horas",
    "seats_class_required": "Es obligatorio el número de plazas por clase.",
    "seats_class_integer": "Las plazas por clase deben ser un número entero.",
    "seats_class_validation": "No puede ser superior a 9999 ni inferior a 0.",
    "meeting_location_required": "Se requiere el lugar de la reunión.",
    "meeting_location_empty": "Por favor, introduzca un valor para todos los tipos de ubicación.",
    "meeting_location_duplicate": "No se permite un valor duplicado para el mismo tipo de ubicación.",
    "meeting_location_booker_multiple": "Preguntar al reservante no está permitido para varios miembros del equipo."
  },
  "custom_values": {
    "assigned_user": "Usuario asignado",
    "full_name": "Nombre completo",
    "first_name": "Nombre",
    "last_name": "Apellidos",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "twilio_phone": "Teléfono de Twilio",
    "account": "Cuenta",
    "name": "Nombre",
    "full_address": "Dirección completa",
    "city": "Ciudad",
    "state": "Región/provincia/estado",
    "country": "País",
    "postal_code": "Código postal",
    "contact": "Contacto",
    "address1": "Dirección 1",
    "timezone": "Zona horaria",
    "user": "Usuario",
    "appointment": "Cita",
    "start_date_time": "Fecha de inicio y hora",
    "start_date": "Fecha de inicio",
    "start_time": "Hora de inicio",
    "end_date_time": "Fecha de finalización",
    "end_date": "Fecha de finalización",
    "end_time": "Hora de finalización",
    "meeting_location": "Lugar de la reunión"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Teléfono",
    "full_address": "Dirección completa",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Personalizado"
  },
  "duration_units": {
    "minutes": "Minutos",
    "hours": "Horario"
  },
  "widget_styles": {
    "classic": "Clásico",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Menú de servicios",
    "rooms": "Salas",
    "equipments": "Equipamientos"
  },
  "lsa": {
    "categories": {
      "accountant": "Contabilidad",
      "acupuncturist": "Acupuntura",
      "air_duct_cleaner": "Limpieza de conductos de aire",
      "alcohol_treatment": "Servicios de tratamiento del alcoholismo",
      "animal_shelter": "Servicios de rescate de animales",
      "appliance_repair": "Reparación de electrodomésticos",
      "architect": "Arquitectura",
      "assisted_living": "Servicios de vida asistida",
      "babysitter": "Canguro",
      "bankruptcy_lawyer": "Ley concursal",
      "beauty_school": "Escuela de Belleza",
      "business_lawyer": "Derecho mercantil",
      "car_repair": "Servicios para automóviles",
      "carpenter": "Carpintería",
      "carpet_cleaning": "Limpieza de alfombras",
      "child_care": "Servicios de cuidado infantil",
      "chiropractor": "Servicios quiroprácticos",
      "cleaning_service": "Limpieza doméstica",
      "contract_lawyer": "Derecho contractual",
      "countertop_pro": "Servicios de encimeras",
      "criminal_lawyer": "Derecho penal",
      "dance_instructor": "Clases de baile",
      "disability_lawyer": "Ley sobre discapacidades",
      "driving_instructor": "Instrucción de conducción",
      "dui_lawyer": "Ley sobre conducción bajo los efectos de sustancias psicoactivas",
      "electrician": "Eléctrico",
      "energy_efficiency_pro": "Servicios de eficiencia energética",
      "estate_lawyer": "Derecho patrimonial",
      "event_planner": "Planificación de eventos",
      "family_lawyer": "Derecho de familia",
      "fencing_pro": "Vallado",
      "financial_planner": "Planificación financiera",
      "first_aid_trainer": "Formación en primeros auxilios",
      "flooring_pro": "Suelos",
      "foundation_pro": "Fundamentos",
      "funeral_home": "Servicios funerarios",
      "garage_door_pro": "Puerta de garaje",
      "general_contractor": "Mejoras de la vivienda",
      "handyman": "Técnico de mantenimiento",
      "home_inspector": "Inspección de viviendas",
      "home_security": "Servicios de seguridad para viviendas",
      "home_theater": "Servicios de cine en casa",
      "hvac": "HVAC",
      "immigration_lawyer": "Ley de inmigración",
      "interior_designer": "Diseño de interiores",
      "ip_lawyer": "Derecho de Propiedad Intelectual",
      "junk_removal": "Eliminación de residuos",
      "labor_lawyer": "Derecho laboral",
      "landscaper": "Paisajismo",
      "language_instructor": "Enseñanza de idiomas",
      "lawn_care": "Cuidado del césped",
      "litigation_lawyer": "Derecho procesal",
      "locksmith": "Cerrajero",
      "malpractice_lawyer": "Ley de negligencia profesional",
      "massage_center": "Servicios de masaje",
      "massage_school": "Escuela de masaje",
      "mover": "Mudanzas",
      "nursing_home": "Servicios de residencia de ancianos",
      "painter": "Pintura",
      "personal_injury_lawyer": "Ley de lesiones personales",
      "personal_trainer": "Entrenamiento personal",
      "pest_control": "Control de plagas",
      "pet_adoption": "Servicios de Adopción de Mascotas",
      "pet_boarding": "Alojamiento de mascotas",
      "pet_grooming": "Aseo de mascotas",
      "pet_trainer": "Entrenamiento de mascotas",
      "photographer": "Fotografía",
      "plumber": "Fontanería",
      "pool_cleaner": "Limpieza de Piscinas",
      "pool_contractor": "Contratación de Piscinas",
      "preschool": "Educación preescolar",
      "psychologist": "Servicios de Psicología",
      "real_estate_agent": "Bienes raíces",
      "real_estate_lawyer": "Ley de bienes raíces",
      "rehab": "Servicios de rehabilitación",
      "roofer": "Cubiertas",
      "sewage_pro": "Servicios del sistema de alcantarillado",
      "siding_pro": "Revestimiento",
      "smart_home": "Servicios para hogares inteligentes",
      "snow_removal": "Servicios de retirada de nieve",
      "spa": "Servicios de Spa",
      "tax_lawyer": "Derecho tributario",
      "tax_specialist": "Servicios fiscales",
      "therapist": "Terapia",
      "towing_pro": "Asistencia en carretera",
      "traffic_lawyer": "Ley de Tráfico",
      "tree_service": "Servicios de árboles",
      "tutor": "Tutoría",
      "upholstery_cleaner": "Limpieza de tapicería",
      "veterinarian": "Servicios veterinarios",
      "videographer": "Servicios de vídeo",
      "water_damage": "Servicios para daños por agua",
      "weight_loss_service": "Servicios de pérdida de peso",
      "window_cleaner": "Limpieza de ventanas",
      "window_repair": "Servicios de ventanas",
      "windshield_repair_pro": "Cristales para automóviles",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Otro",
      "bankruptcy_tax_litigation": "Litigios fiscales por quiebra",
      "bookkeeping": "Contabilidad",
      "business_consulting": "Consultoría de empresa",
      "debt_collection_relief": "Condonación de la cobranza de deudas",
      "irs_representation_resolution": "Representación y resolución del IRS",
      "payroll": "Nómina",
      "tax_planning_business": "Planificación fiscal para empresas",
      "tax_planning_individual": "Planificación fiscal para particulares",
      "tax_return_business": "Devolución de impuestos para empresas",
      "tax_return_individual": "Declaración de impuestos para particulares",
      "trusts_estates_accounting": "Contabilidad de fideicomisos y patrimonios",
      "acupressure": "Acupresión",
      "acupuncture": "Acupuntura",
      "acupuncturist_other": "Otro",
      "cupping": "Encorvamiento",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Terapia de calor",
      "herbal_therapy": "Terapia herbal",
      "infrared_therapy": "Terapia de infrarrojos",
      "moxibustion": "Moxibustión",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Limpieza de conductos de aire",
      "air_duct_filter_replacement": "Sustitución de filtros",
      "air_duct_other": "Otro",
      "dryer_vent_cleaning": "Limpieza de conductos de ventilación de secadoras",
      "furnace_cleaning": "Limpieza de hornos",
      "indoor_air_quality_testing": "Pruebas de calidad del aire interior",
      "alcohol_treatment_other": "Otro",
      "animal_shelter_cat_adoption": "Adopción de gatos",
      "animal_shelter_dog_adoption": "Adopción de perros",
      "animal_shelter_other": "Otro",
      "animal_shelter_other_animal_adoption": "Adopción de otros animales",
      "animal_shelter_other_veterinary_services": "Otros servicios veterinarios",
      "animal_shelter_spay_neuter": "Esterilizar o castrar",
      "animal_shelter_vaccinations": "Vacunas",
      "lost_stray_found_animals": "Animales perdidos, extraviados o encontrados",
      "pet_license": "Licencia de mascotas",
      "pet_surrender": "Entrega de mascotas",
      "appliance_other": "Otro",
      "repair_dishwasher": "Reparar lavavajillas",
      "repair_dryer": "Reparar secadora",
      "repair_freezer": "Reparar congelador",
      "repair_microwave": "Reparar microondas",
      "repair_oven": "Reparar horno",
      "repair_refrigerator": "Reparar refrigerado",
      "repair_refrigerator_freezer": "Reparar frigorífico/congelador",
      "repair_stove_cooktop": "Reparar de hornillos / placas de cocción",
      "repair_stove_cooktop_oven": "Reparar de hornillos / placas de cocción / hornos",
      "repair_washer": "Reparar lavadora",
      "repair_washer_dryer": "Reparar lavadora/secadora",
      "3d_architectural_rendering": "Renderizado arquitectónico 3D",
      "adaptive_reuse_historical_renovation": "Reutilización adaptativa y renovación histórica",
      "architect_other": "Otro",
      "architectural_designing": "Diseño arquitectónico",
      "architectural_engineering": "Ingeniería arquitectónica",
      "building_code_analysis_permit_coordination": "Análisis de códigos y permisos",
      "consulting": "Consultoría",
      "home_building_improvement": "Construcción y mejora de viviendas",
      "interior_design_architect": "Diseño de interiores",
      "planning_zoning_approval_assistance": "Aprobación de planificación y zonificación",
      "project_managing_architect": "Gestión de proyectos",
      "site_master_planning": "Planificación maestra del sitio",
      "assisted_living_housekeeping_and_laundry": "Servicio de limpieza y lavandería",
      "assisted_living_meal_services": "Servicios de comidas",
      "assisted_living_memory_care": "Cuidado de la memoria",
      "assisted_living_other": "Otro",
      "assisted_living_rehabilitation_services": "Servicios de rehabilitación",
      "assisted_living_transportation": "Transporte",
      "assisted_living_wellness_programs": "Programas de bienestar",
      "daily_living_assistance": "Asistencia para el día a día",
      "medication_management": "Gestión de medicamentos",
      "short_term_stays": "Estancias cortas",
      "social_and_recreational_activities": "Actividades recreativas",
      "babysitter_other": "Otro",
      "event_babysitting": "Cuidado de niños para eventos",
      "homework_assistance": "Asistencia con los deberes",
      "housekeeping_laundry": "Servicio de limpieza y lavandería",
      "meal_preparation": "Preparación de comidas",
      "nanny_services": "Servicios de niñera",
      "overnight_babysitting": "Cuidado de niños durante la noche",
      "pick_up_and_drop_off": "Recogida y entrega",
      "shopping_errand": "Compras y recados",
      "special_needs_care": "Atención a necesidades especiales",
      "virtual_babysitting": "Cuidado virtual de niños",
      "agriculture_bankruptcy": "Quiebra agrícola",
      "bankruptcy_lawyer_other": "Otro",
      "bankruptcy_litigation": "Litigios por quiebra",
      "chapter_11_bankruptcy": "Capítulo 11: Quiebra",
      "chapter_13_bankruptcy": "Capítulo 13: Quiebra",
      "chapter_7_bankruptcy": "Capítulo 7: Quiebra",
      "corporate_bankruptcy": "Quiebra corporativa",
      "creditor_harassment": "Acoso de acreedores",
      "debt_settlement": "Liquidación de deudas",
      "foreclosure_bankruptcy_lawyer": "Ejecución hipotecaria",
      "personal_bankruptcy": "Quiebra de particulares",
      "repossession": "Recuperación de bienes",
      "wage_garnishment": "Embargos salariales",
      "beauty_school_barbering": "Barbería",
      "beauty_school_business_management": "Litigios mercantiles",
      "beauty_school_cosmetology": "Cosmetología",
      "beauty_school_esthetics": "Estética",
      "beauty_school_hair_cutting": "Corte de pelo",
      "beauty_school_hair_design": "Diseño de peinados",
      "beauty_school_makeup": "Maquillaje",
      "beauty_school_massage_therapy": "Terapia de masaje",
      "beauty_school_nail_technology": "Tecnología de uñas",
      "beauty_school_other": "Otro",
      "beauty_school_retail_training": "Formación en venta al por menor",
      "banking_finance_law": "Banca y finanzas",
      "business_lawyer_other": "Otro",
      "business_licenses_permits": "Licencias y permisos comerciales",
      "business_litigation": "Litigios empresariales",
      "business_taxes": "Impuestos comerciales",
      "business_transactions_business_lawyer": "Transacciones comerciales",
      "commercial_bankruptcy": "Quiebra comercial",
      "commercial_contracts_business_lawyer": "Contratos comerciales",
      "employment_law_business_lawyer": "Derecho laboral",
      "incorporation_restructuring": "Constitución y reestructuración",
      "insurance_law": "Derecho de seguros",
      "intellectual_property_law": "Derecho de la propiedad intelectual",
      "mergers_acquisitions_business_lawyer": "Fusiones y adquisiciones",
      "partnership_agreements_business_lawyer": "Acuerdos de colaboración",
      "patents_copyrights_trademarks": "Patentes, derechos de autor y marcas comerciales",
      "securities_law": "Ley de valores",
      "shareholder_disputes": "Disputas entre accionistas",
      "air_and_cabin_filter": "Filtro de aire y cabina",
      "battery": "Batería",
      "body_and_trim": "Cuerpo y recortar",
      "brakes": "Frenos",
      "car_air_conditioning": "Aire acondicionado",
      "car_electrical": "Eléctrico",
      "car_repair_other": "Otro",
      "check_engine_light_diagnostic": "Diagnóstico de la luz de avería del motor",
      "exhaust": "Escape",
      "oil_change": "Cambio de aceite",
      "steering_suspension": "Dirección / Suspensión",
      "tires": "Neumáticos",
      "transmission": "Transmisión",
      "cabinetry": "Ebanistería",
      "carpenter_other": "Otro",
      "decking": "Cubierta",
      "drywalling": "Instalación de paneles de yeso",
      "fencing": "Vallado",
      "general_installations": "Instalaciones generales",
      "general_repairs_maintenance": "Reparaciones generales y mantenimiento",
      "remodeling": "Remodelaciones",
      "shelving_storage": "Estanterías y almacenamiento",
      "carpet_cleaning_other": "Otro",
      "clean_area_rugs": "Limpieza de alfombras",
      "clean_carpet": "Limpieza de moquetas",
      "clean_drapes_and_curtains": "Limpieza de cortinas y visillos",
      "clean_upholstery": "Limpieza de tapicería",
      "remove_pet_stains_and_odors": "Eliminar manchas y olores de mascotas",
      "after_school_care": "Servicio de guardería después del colegio",
      "all_hours_daycare": "Guardería las 24 horas",
      "bilingual_daycare": "Guardería bilingüe",
      "child_care_other": "Otro",
      "drop_in_daycare": "Guardería sin cita previa",
      "full_time_daycare": "Guardería a tiempo completo",
      "in_home_daycare": "Guardería en casa",
      "infant_programs": "Programas para bebés",
      "part_time_daycare": "Guardería a tiempo parcial",
      "pre_kindergarten_programs": "Programas de preescolar",
      "preschool_programs": "Programas de preescolar",
      "school_age_programs": "Programas para edad escolar",
      "special_needs_daycare": "Guardería para necesidades especiales",
      "summer_daycare": "Guardería de verano",
      "toddler_programs": "Programas para niños pequeños",
      "weekend_daycare": "Guardería de fin de semana",
      "chiropractor_acupuncture": "Acupuntura",
      "chiropractor_chiropractic": "Quiropráctica",
      "chiropractor_massage_therapy": "Terapia de masaje",
      "chiropractor_other": "Otro",
      "diagnosis": "Diagnóstico",
      "eastern_medicine": "Medicina oriental",
      "exercise_counseling": "Asesoramiento sobre ejercicio",
      "pain_management": "Gestión del dolor",
      "physical_therapy": "Fisioterapia",
      "spinal_adjustments": "Ajustes de la columna vertebral",
      "sports_medicine": "Medicina deportiva",
      "cleaner_other": "Otro",
      "deep_clean": "Limpieza profunda",
      "moving_clean": "Limpieza de mudanzas",
      "office_clean": "Limpieza de oficina",
      "standard_clean": "Limpieza estándar",
      "assignment_of_contract": "Cesión de contrato",
      "business_transactions_contract_lawyer": "Transacciones comerciales",
      "commercial_contracts_contract_lawyer": "Contratos comerciales",
      "contract_dispute": "Conflicto contractual",
      "contract_lawyer_other": "Otro",
      "contract_negotiation": "Negociación de contratos",
      "contract_review": "Revisión de contratos",
      "employment_contracts_contract_lawyer": "Contratos laborales",
      "franchise_agreements": "Acuerdos de franquicia",
      "mergers_acquisitions_contract_lawyer": "Fusiones y adquisiciones",
      "non_disclosure_agreements_contract_lawyer": "Acuerdos de confidencialidad",
      "partnership_agreements_contract_lawyer": "Acuerdos de colaboración",
      "power_of_attorney_contract_lawyer": "Poder notarial",
      "security_agreements": "Acuerdos de Seguridad",
      "warranties": "Garantías",
      "bathroom_countertops": "Encimeras de baño",
      "bathroom_wall_panels": "Paneles de pared para baños",
      "countertop_design": "Diseño de encimeras",
      "countertop_installation": "Instalación de encimeras",
      "countertop_pro_other": "Otro",
      "fireplace_facade": "Fachada de chimeneas",
      "granite_countertops": "Encimeras de granito",
      "kitchen_countertops": "Encimeras de cocina",
      "kitchen_wall_panels": "Paneles de pared para cocina",
      "laminate_countertops": "Encimeras laminadas",
      "marble_countertops": "Encimeras de mármol",
      "quartz_countertops": "Encimeras de cuarzo",
      "remodeling_countertop_pro": "Remodelaciones",
      "repair_maintenance_countertop_pro": "Reparación y mantenimiento",
      "stone_slab_countertops": "Encimeras de losa de piedra",
      "tile_countertops": "Encimeras de azulejos",
      "corporate_representation": "Representación corporativa",
      "criminal_immigration_defense": "Defensa penal de inmigración",
      "criminal_lawyer_other": "Otro",
      "domestic_violence": "Violencia doméstica",
      "drug_possession": "Posesión de drogas",
      "duis_reckless_driving": "Conducción bajo los efectos de sustancias psicoactivas y conducción temeraria",
      "expungement": "Eliminación de antecedentes penales",
      "federal_crimes": "Delitos federales",
      "felonies": "Delitos graves",
      "petty_crimes_misdemeanors": "Delitos menores y faltas",
      "restraining_orders": "Órdenes de alejamiento",
      "sex_offenses": "Delitos de género",
      "three_strikes_law": "Ley de los «tres strikes»",
      "dance_instructor_african": "Africano",
      "dance_instructor_ballet": "Ballet",
      "dance_instructor_ballroom": "Salón de Baile",
      "dance_instructor_belly": "Vientre",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Contemporáneo",
      "dance_instructor_folk_traditional": "Folclore y tradicional",
      "dance_instructor_hip_hop": "Hip hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Cursos para niños",
      "dance_instructor_latin": "Latín",
      "dance_instructor_modern": "Moderno",
      "dance_instructor_other": "Otro",
      "dance_instructor_tap": "Tocar",
      "dance_instructor_wedding": "Boda",
      "disability_hearings": "Audiencias sobre discapacidad",
      "disability_lawyer_other": "Otro",
      "long_term_disability": "Discapacidad a largo plazo",
      "short_term_disability": "Discapacidad a corto plazo",
      "social_security_disability_insurance": "Seguro social por incapacidad laboral",
      "ssa_claim_reconsideration": "Reconsideración de reclamaciones de la SSA",
      "ssa_disability_appeals": "Apelaciones por discapacidad de la SSA",
      "ssa_disability_applications": "Aplicaciones de discapacidad de la SSA",
      "ssa_disability_benefits": "Prestaciones por discapacidad de la SSA",
      "ssa_family_benefits": "Beneficios familiares de la SSA",
      "ssa_impairment_listings": "Lista de discapacidades de la SSA",
      "supplemental_security_income": "Ingresos suplementarios de seguridad",
      "veterans_disability_benefits": "Prestaciones por discapacidad para veteranos",
      "workers_compensation_disability_lawyer": "Compensación de los trabajadores",
      "behind_the_wheel_lessons": "Clases de conducción",
      "commercial_license_training": "Formación para licencias comerciales",
      "defensive_driving_lessons": "Lecciones de conducción defensiva",
      "drivers_education_classes": "Cursos de educación vial",
      "driving_instructor_other": "Otro",
      "manual_transmission_lessons": "Clases de transmisión manual",
      "motorcycle_lessons": "Clases de motocicleta",
      "traffic_school": "Escuela de conducción",
      "dui_dwi_dui_lawyer": "Conducción bajo los efectos de sustancias psicoactivas",
      "dui_injuries_dui_lawyer": "Conducción bajo los efectos de sustancias psicoactivas con lesiones",
      "dui_lawyer_other": "Otro",
      "dui_with_accident": "Conducción bajo los efectos de sustancias psicoactivas con accidente",
      "felony_dui": "Delito grave por conducir bajo los efectos de sustancias psicoactivas",
      "invalid_tests": "Pruebas no válidas",
      "multiple_offenses": "Múltiples infracciones",
      "reckless_driving_dui_lawyer": "Conducción temeraria",
      "underage_dui": "Menores de edad conduciendo bajo los efectos de sustancias psicoactivas",
      "electric_car_charger": "Instalar cargador para coche eléctrico",
      "electrician_other": "Otro",
      "electrician_remodeling": "Remodelaciones",
      "install_fan": "Instalar ventilador",
      "install_ground_wire": "Instalar toma de tierra",
      "install_light_fixtures": "Instalar luminarias",
      "install_outdoor_lighting": "Instalar iluminación exterior",
      "install_outlets_switches": "Instalar tomas o interruptores",
      "install_security_system": "Instalar sistema de seguridad",
      "relocate_outlets_switches": "Mover las tomas de corriente o los interruptores",
      "repair_fan": "Reparar ventilador",
      "repair_light_fixtures": "Reparar luminarias",
      "repair_outlets_switches": "Reparar enchufes o interruptores",
      "repair_panel": "Panel de reparación",
      "replace_upgrade_panel": "Reemplazar o actualizar panel",
      "restore_power": "Restablecer la energía",
      "energy_efficiency_pro_other": "Otro",
      "charitable_giving": "Donaciones benéficas",
      "contests_litigation": "Concursos / Litigios",
      "deeds": "Escrituras",
      "estate_lawyer_other": "Otro",
      "estate_planning_lawyer": "Planificación patrimonial",
      "guardianship_estate_lawyer": "Tutela",
      "medical_power_of_attorney": "Poder notarial médico",
      "power_of_attorney_estate_lawyer": "Poder notarial",
      "probate_estate_lawyer": "Abogado especializado en sucesiones",
      "trusts": "Fideicomisos",
      "wills": "Testamentos",
      "anniversary_planner": "Aniversario",
      "baby_shower_planner": "Fiesta del bebé",
      "bar_and_bat_mitzvah_planner": "Bar y bat mitzvá",
      "birthday_party": "Fiesta de cumpleaños",
      "children_party": "Fiesta infantil",
      "corporate_and_conference_planner": "Corporativo y conferencias",
      "event_planner_other": "Otro",
      "quinceanera_planner": "Quinceañera",
      "religious_event": "Evento religioso",
      "retirement_party": "Fiesta de jubilación",
      "school_event": "Evento escolar",
      "theme_party": "Fiesta temática",
      "wedding_and_engagement_planner": "Bodas y compromisos",
      "adoption": "Adopción",
      "child_support": "Manutención de los hijos",
      "contested_divorce": "Divorcio contencioso",
      "debt_division": "Departamento de deudas",
      "family_lawyer_other": "Otro",
      "guardianship_family_lawyer": "Tutela",
      "mediation_family_lawyer": "Mediación",
      "modifications_of_orders": "Modificación de pedidos",
      "parent_timesharing": "Custodia compartida",
      "paternity": "Paternidad",
      "prenuptial_postnuptial_agreements": "Acuerdos prenupciales y matrimoniales",
      "probate_family_lawyer": "Sucesiones",
      "property_divisions": "División de propiedades",
      "protective_orders_domestic_violence_issues": "Órdenes de restricción",
      "spousal_support_alimony": "Manutención conyugal y pensión alimenticia",
      "uncontested_divorce": "Divorcio de mutuo acuerdo",
      "custom_construction": "Construcción personalizada",
      "fence_design": "Diseño de vallas",
      "fencing_other": "Otro",
      "installation_fencing_pro": "Instalación de vallas",
      "repairs_maintenance_fencing_pro": "Reparaciones y mantenimiento",
      "education_savings": "Ahorros para la educación",
      "estate_financial_planning": "Planificación patrimonial",
      "financial_planning": "Planificación financiera",
      "financial_planning_other": "Otro",
      "home_purchase": "Compra de vivienda",
      "insurance": "Seguro",
      "investment_advising": "Asesoramiento de inversiones",
      "retirement_savings": "Jubilación",
      "tax_planning": "Planificación fiscal",
      "advanced_cardiac_life_support": "Soporte vital cardíaco avanzado",
      "aed_defibrillator": "DEA - Desfibrilador",
      "basic_life_support": "Soporte vital básico",
      "cpr": "RCP",
      "first_aid": "Primeros auxilios",
      "first_aid_trainer_other": "Otro",
      "pediatric_advanced_life_support": "Soporte vital avanzado pediátrico",
      "pediatric_cpr_first_aid": "RCP y primeros auxilios pediátricos",
      "pet_cpr_first_aid": "RCP y primeros auxilios para mascotas",
      "wilderness_first_aid": "Primeros auxilios en zonas silvestres",
      "baseboards": "Zócalos",
      "carpet": "Alfombra",
      "flooring_other": "Otro",
      "hardwood": "Madera dura",
      "installation_flooring_pro": "Instalación de suelos",
      "marble": "Mármol",
      "polishing": "Pulido de suelos",
      "refinishing": "Reacabado de suelos",
      "repair_maintenance_flooring_pro": "Reparación y mantenimiento de suelos",
      "stair_flooring": "Revestimiento de escaleras",
      "tile": "Azulejos",
      "wood_floor_sanding": "Lijado de suelos de madera",
      "basement_waterproofing": "Impermeabilización de sótanos",
      "crawl_spaces": "Cimientos del espacio bajo el suelo",
      "foundation_drainage": "Drenaje de cimientos",
      "foundation_installation": "Instalación de cimientos",
      "foundation_pro_other": "Otro",
      "foundation_raising": "Levantamiento de cimientos",
      "repairs_maintenance_foundation_pro": "Reparaciones y mantenimiento",
      "slab_foundation": "Cimentación de losa",
      "steel_pier_pilings": "Pilotes de acero para muelles",
      "water_moisture_control": "Control del agua y la humedad",
      "burials": "Entierros",
      "caskets": "Ataúdes",
      "cremation": "Cremación",
      "funeral_home_flowers": "Flores",
      "funeral_home_other": "Otro",
      "funeral_home_transportation_transfers": "Transporte y traslados",
      "funeral_home_veteran_services": "Servicios para veteranos",
      "funerals": "Funerales",
      "gravestones": "Lápidas",
      "grief_services": "Servicios de atención al duelo",
      "memorials": "Memoriales",
      "urns": "Urnas",
      "garage_door_other": "Otro",
      "general_maintenance": "Mantenimiento general",
      "install_garage_door": "Instalar puerta de garaje",
      "install_opener": "Instalar mecanismo apertura",
      "repair_cables": "Reparar cables",
      "repair_garage_door": "Reparar puerta de garaje",
      "repair_gate": "Reparar puerta",
      "repair_rollers_tracks": "Reparar rodillos y rieles",
      "replace_door_panels": "Reemplazar paneles de puertas",
      "replace_opener": "Reemplazar mecanismo apertura",
      "replace_springs": "Reemplazar resortes",
      "accessory_buildings": "Edificios auxiliares",
      "bathroom_remodel": "Reforma del baño",
      "decks_patio": "Terrazas y patios",
      "exterior_finishing": "Acabado exterior",
      "foundations_concrete": "Cimientos y hormigón",
      "general_contractor_commercial_projects": "Proyectos comerciales",
      "general_contractor_other": "Otro",
      "home_addition": "Ampliación de viviendas",
      "home_building": "Construcción de viviendas",
      "home_remodel_renovation": "Remodelación y renovación de viviendas",
      "interior_finishing": "Acabado interior",
      "kitchen_remodel": "Reforma de cocina",
      "roofing": "Cubiertas",
      "assemble_furniture": "Montar muebles",
      "clean_gutters": "Limpieza de canalones",
      "handyman_other": "Otro",
      "install_drywall": "Instalar paneles de yeso",
      "install_flooring": "Instalar suelo",
      "install_tile": "Instalar azulejos",
      "install_water_fixtures": "Instalar accesorios de agua",
      "mount_tv": "Montar la TV",
      "paint_indoors": "Pintar interiores",
      "paint_outdoors": "Pintar exteriores",
      "repair_drywall": "Reparar paneles de yeso",
      "repair_flooring": "Reparar suelos",
      "repair_water_fixtures": "Reparar instalaciones de agua",
      "replace_tile": "Reemplazar azulejos",
      "buyer_seller_inspection": "Inspección de comprador y comerciante",
      "commercial_properties": "Propiedades Comerciales",
      "fire_safety": "Seguridad contra incendios",
      "fireplace_chimney": "Chimenea y hogar",
      "full_home_inspection": "Inspección completa de la vivienda",
      "home_inspector_electrical": "Eléctrico",
      "home_inspector_foundation": "Cimientos",
      "home_inspector_hvac": "Sistemas de climatización",
      "home_inspector_mold": "Moho",
      "home_inspector_new_construction": "Nueva construcción",
      "home_inspector_other": "Otro",
      "home_inspector_plumbing": "Fontanería",
      "home_inspector_roof": "Tejado",
      "home_inspector_structural": "Estructural",
      "home_warranty": "Garantía de la vivienda",
      "water_testing": "Análisis del agua",
      "well_or_septic_system": "Pozo o sistema séptico",
      "wood_insects": "Madera e insectos",
      "access_control": "Control de acceso",
      "alarm_systems": "Sistemas de alarma",
      "commercial_security_systems": "Sistemas de seguridad comercial",
      "fire_smoke_detection": "Detección de incendios y humo",
      "home_security_doors": "Puertas",
      "home_security_locks": "Cerraduras",
      "home_security_other": "Otro",
      "home_security_windows": "Ventanas",
      "monitoring_services": "Servicios de supervisión",
      "residential_security_systems": "Sistemas de seguridad residencial",
      "smart_home_integration": "Integración en hogares inteligentes",
      "video_surveillance": "Videovigilancia",
      "audio_video_installation": "Instalación de audio y vídeo",
      "commercial_projects": "Proyectos comerciales",
      "home_theater_design": "Diseño de cine en casa",
      "home_theater_lighting": "Iluminación",
      "home_theater_other": "Otro",
      "home_theater_smart_home_integration": "Integración en hogares inteligentes",
      "install_tv": "Instalar TV",
      "network_it_services": "Servicios de red y TI",
      "outdoor_installations": "Instalaciones al aire libre",
      "soundproofing": "Insonorización",
      "whole_house_audio_video": "Audio y vídeo para toda la vivienda",
      "ac_maintenance": "Mantenimiento del aire acondicionado",
      "clean_ducts_vents": "Limpieza conductos y rejillas de ventilación",
      "ductless_heating_and_ac_services": "Servicios de calefacción y aire acondicionado sin conductos",
      "heating_maintenance": "Mantenimiento de calefacción",
      "hvac_maintenance": "Mantenimiento de HVAC",
      "hvac_other": "Otro",
      "install_ac": "Instalar aire acondicionado",
      "install_ducts_vents": "Instalar conductos y rejillas de ventilación",
      "install_heating_system": "Instalar sistema de calefacción",
      "install_thermostat": "Instalar termostato",
      "repair_ac": "Reparar aire acondicionado",
      "repair_ducts_vents": "Reparar conductos y rejillas de ventilación",
      "repair_heating_system": "Reparar el sistema de calefacción",
      "repair_hvac": "Reparar sistema de climatización",
      "repair_thermostat": "Reparar termostato",
      "asylum": "Asilo",
      "citizenship": "Ciudadanía",
      "deportation": "Deportación",
      "family_based_immigration": "Inmigración por motivos familiares",
      "green_card": "Tarjeta verde",
      "immigration_lawyer_other": "Otro",
      "investment_visa": "Visa de inversión",
      "outbound_work_permits": "Permisos de trabajo en el extranjero",
      "student_visa": "Visa de estudiante",
      "visitor_visa": "Visado de visitante",
      "work_visa": "Visa de trabajo",
      "appliance_selection": "Selección de electrodomésticos",
      "cabinetry_molding_hardware_design": "Diseño de ebanistería y herrajes",
      "decorating": "Decoración",
      "door_design": "Diseño de puertas",
      "exterior_building_design": "Diseño exterior de edificios",
      "flooring_selection": "Selección de suelos",
      "interior_designer_other": "Otro",
      "landscaping_design": "Diseño paisajístico",
      "lighting_design": "Diseño de iluminación",
      "multifamily_housing_design": "Diseño de viviendas multifamiliares",
      "room_planning": "Planificación de salas",
      "stone_brick_stucco_design": "Diseño en piedra, ladrillo y estuco",
      "window_design": "Diseño de ventanas",
      "advertisements": "Anuncios",
      "copyright": "Derechos de autor",
      "export_control": "Control de exportaciones",
      "franchises": "Franquicias",
      "international_ip": "IP internacional",
      "ip_lawyer_other": "Otro",
      "ip_strategy": "Estrategia de la propiedad intelectual",
      "ip_transactions": "Transacciones de propiedad intelectual",
      "licensing": "Licencias",
      "litigation_ip_lawyer": "Litigio",
      "non_disclosure_agreements_ip_lawyer": "Acuerdos de Confidencialidad",
      "patents": "Patentes",
      "technology_transfer": "Transferencia de tecnología",
      "trade_secrets": "Secretos comerciales",
      "trademarks": "Marcas comerciales",
      "appliance_removal": "Retiro de electrodomésticos",
      "construction_waste_removal": "Eliminación de residuos de construcción",
      "donation_pickup": "Recogida de donativos",
      "electronic_waste_removal": "Eliminación de residuos electrónicos",
      "furniture_removal": "Traslado de muebles",
      "general_junk_removal": "Eliminación general de residuos",
      "hazardous_waste_removal": "Eliminación de residuos peligrosos",
      "house_garage_cleanout": "Limpieza de casa/garaje",
      "junk_removal_other": "Otro",
      "yard_waste_removal": "Eliminación de desechos de jardín",
      "employment_contracts_labor_lawyer": "Contratos laborales",
      "employment_law_labor_lawyer": "Derecho laboral",
      "exempt_employee_status": "Estado de empleado exento",
      "labor_law": "Derecho laboral",
      "labor_lawyer_other": "Otro",
      "labor_negotiations": "Negociaciones laborales",
      "privacy_rights": "Derechos de privacidad",
      "sexual_harassment": "Acoso sexual",
      "unpaid_overtime": "Horas extras no remuneradas",
      "whistle_blowing": "Denuncia de irregularidades",
      "workers_compensation_labor_lawyer": "Compensación de los trabajadores",
      "wrongful_termination": "Despido improcedente",
      "artificial_turf_installation": "Instalación de césped artificial",
      "concrete_masonry": "Mampostería de hormigón",
      "driveway_landscaping": "Paisajismo de accesos para vehículos",
      "garden_decorations": "Decoraciones de jardín",
      "grading_resloping": "Nivelación y reconfiguración del terreno",
      "hardscapes": "Elementos estructurales del jardín",
      "landscape_design": "Diseño paisajístico",
      "landscape_installations": "Instalaciones paisajísticas",
      "landscaper_other": "Otro",
      "outdoor_steps": "Escalones exteriores",
      "outdoor_water_feature": "Elementos acuáticos para exteriores",
      "paving_driveway_walkway": "Pavimentación de accesos para vehículos y peatonales",
      "retaining_walls": "Muros de contención",
      "sidewalk_walkway_landscaping": "Paisajismo de caminos",
      "sod_seeding": "Instalación y siembra de césped",
      "stone_masonry": "Mampostería de piedra",
      "arabic": "Arabic",
      "english": "English",
      "french": "French",
      "german": "German",
      "hebrew": "Hebreo",
      "italian": "Italian",
      "japanese": "Japanese",
      "korean": "Korean",
      "language_instructor_other": "Otro",
      "mandarin": "Mandarín",
      "portuguese": "Portugués",
      "russian": "Russian",
      "sign_language": "lengua de signos",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Reparación / mantenimiento del sistema de riego",
      "lawn_care_other": "Otro",
      "lawn_mowing_maintenance": "Corte/mantenimiento del césped",
      "lawn_pest_control": "Control de plagas en el césped",
      "mulching": "Acolchado",
      "seeding": "Siembra",
      "sod_installation": "Instalación de césped",
      "weed_control": "Control de malezas",
      "yard_cleanup": "Limpieza del jardín",
      "appeals": "Apelaciones",
      "case_assessment_litigation_lawyer": "Evaluación de casos",
      "civil_litigation": "Litigación civil",
      "commercial_litigation": "Litigios comerciales",
      "contracts_and_agreements": "Contratos y acuerdos",
      "criminal_litigation": "Litigación penal",
      "litigation_lawyer_other": "Otro",
      "mediation_litigation_lawyer": "Mediación",
      "settlements": "Liquidaciones",
      "building_lockout": "Cierre de edificios",
      "copy_building_key": "Copiar llaves del edificio",
      "copy_vehicle_key": "Copiar llave del vehículo",
      "install_hardware": "Instalar hardware",
      "locksmith_other": "Otro",
      "new_key_fob": "Nuevo llavero electrónico",
      "rekey_lock": "Reconfigurar la combinación de la cerradura",
      "repair_hardware": "Reparar hardware",
      "vehicle_lockout": "Bloqueo del vehículo",
      "consent_issues": "Cuestiones relacionadas con el consentimiento",
      "diagnosis_errors": "Errores de diagnóstico",
      "malpractice_lawyer_other": "Otro",
      "medical_negligence": "Negligencia médica",
      "treatment_errors": "Errores de tratamiento",
      "massage_center_other": "Otro",
      "massage_school_advanced_neuromuscular_therapy": "Terapia Neuromuscular Avanzada",
      "massage_school_business_and_ethics": "Empresa y ética",
      "massage_school_clinical_therapies": "Terapias clínicas",
      "massage_school_continuing_education": "Formación continua",
      "massage_school_deep_tissue_massage": "Masaje de tejido profundo",
      "massage_school_energetics": "Energético",
      "massage_school_hydrotherapy": "Hidroterapia",
      "massage_school_lymphatic_massage": "Masaje linfático",
      "massage_school_online_massage_therapy": "Terapia de masaje en línea",
      "massage_school_other": "Otro",
      "massage_school_prenatal_massage": "Masaje prenatal",
      "massage_school_sports_massage": "Masaje Deportivo",
      "massage_school_student_massage_clinic": "Clínica de masajes para estudiantes",
      "massage_school_swedish_massage": "Masaje sueco",
      "massage_theory": "Teoría del masaje",
      "massage_therapy_training": "Cursos de terapia de masaje",
      "in_state_move": "Traslado dentro del estado",
      "local_move": "Traslado local",
      "mover_other": "Otro",
      "moving_junk_removal": "Eliminación de residuos",
      "moving_storage": "Almacenamiento",
      "out_of_state_move": "Traslado fuera del estado",
      "oversized_item_move": "Traslado de artículos de gran tamaño",
      "packing_unpacking": "Embalado/desembalado",
      "senior_move": "Traslado de personas mayores",
      "vehicle_transport": "Transporte de vehículos",
      "cardiac_care": "Atención cardíaca",
      "general_medical_care": "Atención médica general",
      "hospice": "Hospicio",
      "iv_therapy": "Terapia intravenosa",
      "nursing_home_meal_services": "Servicios de comidas",
      "nursing_home_memory_care": "Cuidado de la memoria",
      "nursing_home_other": "Otro",
      "nursing_home_pain_management": "Gestión del dolor",
      "nursing_home_rehabilitation_services": "Servicios de rehabilitación",
      "nursing_home_wellness_programs": "Programas de bienestar",
      "outpatient_rehabilitation": "Rehabilitación ambulatoria",
      "post_hospital_care": "Atención poshospitalaria",
      "respiratory_and_pulmonary_care": "Cuidado respiratorio y pulmonar",
      "senior_activity_programs": "Programas de actividades para personas mayores",
      "short_term_rehabilitation": "Rehabilitación a corto plazo",
      "wound_care": "Cuidado de heridas",
      "exterior_painting": "Pintura exterior",
      "interior_painting": "Pintura de interiores",
      "paint_cabinets": "Pintar armarios",
      "paint_doors": "Pintar puertas",
      "painter_other": "Otro",
      "repair_water_damage": "Reparar daños causados por el agua",
      "staining": "Tinción",
      "assault_battery": "Asalto y agresión",
      "auto_accidents": "Accidentes automovilísticos",
      "bicycle_accidents": "Accidentes de Bicicleta",
      "catastrophic_injuries": "Lesiones catastróficas",
      "dog_bites": "Mordeduras de perro",
      "dui_injuries_personal_injury_lawyer": "Lesiones causadas por conducir bajo los efectos de sustancias psicoactivas",
      "medical_malpractice": "Mala praxis médica",
      "motorcycle_accidents": "Accidentes de motocicleta",
      "pain_suffering": "Dolor y sufrimiento",
      "pedestrian_accidents": "Accidentes de peatones",
      "personal_injury_lawyer_other": "Otro",
      "product_liability": "Responsabilidad de productos",
      "slip_fall": "Resbalón y caída",
      "uninsured_motorist_claims": "Reclamaciones de seguros de automóviles",
      "workers_compensation_personal_injury_lawyer": "Compensación de los trabajadores",
      "wrongful_death": "Muerte por negligencia",
      "aerobics": "Aerobic",
      "athletic_performance": "Rendimiento atlético",
      "circuit_training": "Entrenamiento en circuito",
      "endurance": "Resistencia",
      "fitness_assessment": "Evaluación física",
      "hiit": "HIIT",
      "nutritional_counseling": "Asesoramiento nutricional",
      "personal_trainer_other": "Otro",
      "strength_conditioning": "Fuerza y acondicionamiento",
      "weight_loss": "Pérdida de peso",
      "yoga": "Yoga",
      "ants": "Hormigas",
      "bed_bugs": "Chinches de cama",
      "bees": "Abejas",
      "cockroaches": "Cucarachas",
      "fleas_or_mites": "Pulgas o ácaros",
      "hornets_or_wasps": "Avispones o avispas",
      "mosquitoes": "Mosquitos",
      "pest_control_other": "Otro",
      "pest_inspection": "Inspección",
      "rodents": "Roedores",
      "spiders": "Arañas",
      "termites": "Termitas",
      "wildlife": "Fauna",
      "pet_adoption_birds": "Aves",
      "pet_adoption_cats": "Gatos",
      "pet_adoption_dogs": "Perros",
      "pet_adoption_farm_animals": "Animales de Granja",
      "pet_adoption_fish": "Pescado",
      "pet_adoption_other": "Otro",
      "pet_adoption_reptiles": "Reptiles",
      "pet_adoption_small_mammals": "Pequeños mamíferos",
      "pet_adoption_special_needs_animals": "Animales con necesidades especiales",
      "cat_boarding": "Alojamiento de gatos",
      "cat_grooming": "Aseo de gatos",
      "cat_sitting_in_home": "Cuidado de gatos (en casa)",
      "dog_boarding": "Alojamiento de perros",
      "dog_boarding_with_training": "Alojamiento de perros con entrenamiento",
      "dog_daycare": "Guardería para perros",
      "dog_grooming": "Peluquería canina",
      "dog_sitting_in_home": "Cuidado de perros (en casa)",
      "dog_training": "Entrenamiento de perros",
      "dog_walking": "Paseo de perros",
      "other_pet_boarding": "Otros servicios de alojamiento para mascotas",
      "other_pet_daycare": "Otros servicios de guardería para mascotas",
      "other_pet_grooming": "Otros servicios de peluquería para mascotas",
      "other_pet_sitting_in_home": "Otros servicios de cuidado de mascotas (a domicilio)",
      "pet_boarding_other": "Otro",
      "cat_bathing": "Baño de gatos",
      "cat_ear_cleaning": "Limpieza de orejas de gato",
      "cat_grooming_and_styling": "Peluquería y estilismo para gatos",
      "cat_nail_trimming": "Corte de uñas de gato",
      "dog_anal_gland_expression": "Expresión de la glándula anal del perro",
      "dog_bathing_and_blow_dry": "Baño y secado de perros",
      "dog_ear_cleaning": "Limpieza de oídos de perros",
      "dog_flea_and_tick_treatment": "Tratamiento anti pulgas y garrapatas para perros",
      "dog_full_service_grooming": "Servicio completo de peluquería para perros",
      "dog_grooming_and_styling": "Peluquería y estilismo canino",
      "dog_nail_trimming": "Corte de uñas de perro",
      "dog_teeth_brushing": "Limpieza dental canina",
      "pet_grooming_other": "Otro",
      "aggressive_dog_training": "Adiestramiento de perros agresivos",
      "behavior_modification": "Modificación del comportamiento",
      "obedience_training": "Entrenamiento de obediencia",
      "offleash_training": "Entrenamiento sin correa",
      "pet_trainer_other": "Otro",
      "puppy_training": "Adiestramiento de cachorros",
      "service_animal_training": "Entrenamiento de animales de servicio",
      "sport_trick_training": "Entrenamiento deportivo o entrenamiento de trucos",
      "training_other_animals": "Entrenamiento de otros animales",
      "corporate_photo": "Corporativo",
      "events_and_parties_photo": "Eventos y fiestas",
      "family_and_group_photo": "Familia y grupo",
      "headshots_and_portraits": "Retratos y fotos de carnet",
      "individual_photo": "Individual",
      "maternity_and_newborn_photo": "Maternidad y recién nacido",
      "photographer_other": "Otro",
      "product_photo": "Producto",
      "real_estate_photo": "Bienes raíces",
      "school_portraits": "Retratos Escolares",
      "wedding_and_engagement_photo": "Bodas y compromisos",
      "find_leak": "Encontrar y reparar fugas",
      "install_faucet": "Instalar grifo",
      "install_garbage_disposal": "Instalar triturador de basura",
      "install_shower": "Instalar ducha",
      "install_toilet": "Instalar inodoro",
      "install_water_heater": "Instalar el calentador de agua",
      "plumbing_other": "Otro",
      "repair_faucet": "Reparar grifo",
      "repair_garbage_disposal": "Reparar triturador de basura",
      "repair_outdoor_systems": "Reparar sistemas exteriores",
      "repair_pipe": "Reparar tubería",
      "repair_sewer": "Reparar desagüe",
      "repair_shower": "Reparar ducha",
      "repair_toilet": "Reparar inodoro",
      "repair_water_heater": "Reparar calentador de agua",
      "unclog_drain": "Desatascar desagüe",
      "commercial_pool_cleaning_maintenance": "Limpieza y mantenimiento de piscinas comerciales",
      "equipment_maintenance_repair": "Mantenimiento y reparación de equipamientos",
      "one_time_pool_cleaning": "Limpieza puntual de piscinas",
      "ongoing_pool_cleaning": "Limpieza periódica de la piscina",
      "pool_cleaner_other": "Otro",
      "pool_cleaner_water_features": "Elementos acuáticos",
      "seasonal_opening_closing": "Apertura y cierre estacional",
      "spa_hot_tub_cleaning": "Limpieza de spas y jacuzzis",
      "spa_hot_tub_repairs": "Reparaciones de spas y jacuzzis",
      "tile_pool_wall_cleaning": "Limpieza de azulejos y paredes de piscina",
      "water_testing_balancing": "Análisis y ajuste químico del agua",
      "jetted_lap_pools": "Piscinas de entrenamiento con chorros",
      "pool_construction": "Construcción de piscinas",
      "pool_contractor_commercial_projects": "Proyectos comerciales",
      "pool_contractor_custom_designs": "Diseños personalizados",
      "pool_contractor_other": "Otro",
      "pool_contractor_renovation": "Renovación",
      "pool_contractor_repair_cracks": "Reparar grietas",
      "pool_contractor_repair_tile": "Reparar baldosa",
      "pool_contractor_resurfacing": "Reacondicionamiento",
      "pool_contractor_water_features": "Elementos acuáticos",
      "pool_hot_tub_equipment": "Equipos para piscinas y jacuzzis",
      "spa_hot_tub_installation": "Instalación de spas y jacuzzis",
      "bilingual_programs": "Programas bilingües",
      "early_preschool": "Primer ciclo de preescolar",
      "full_day_preschool": "Preescolar de jornada completa",
      "half_day_preschool": "Preescolar de medio día",
      "kindergarten_classes": "Cursos de jardín de infancia",
      "montessori_programs": "Programas Montessori",
      "play_based_preschool": "Preescolar basado en el juego",
      "preschool_infant_programs": "Programas para bebés",
      "preschool_other": "Otro",
      "reggio_emilia_preschool": "Preescolar Reggio Emilia",
      "special_needs_programs": "Programas de necesidades especiales",
      "summer_camp": "Campamento de Verano",
      "waldorf_preschool": "Preescolar Waldorf",
      "psychologist_other": "Otro",
      "buyer_agent": "Agente del comprador",
      "first_time_home_buyer": "Comprador de vivienda por primera vez",
      "foreclosed_properties": "Propiedades embargadas",
      "luxury_properties": "Propiedades de lujo",
      "new_construction": "Nueva construcción",
      "property_management": "Gestión de propiedades",
      "real_estate_agent_other": "Otro",
      "relocation": "Reubicación",
      "rentals": "Alquileres",
      "sellers_agent": "Agente del vendedor",
      "commercial_real_estate": "Bienes raíces comerciales",
      "easements": "Servidumbres",
      "encroachment": "Ocupación de espacio",
      "foreclosure_real_esate_lawyer": "Ejecución hipotecaria",
      "landlord_tenant_law": "Ley de arrendadores y arrendatarios",
      "litigation_real_estate_lawyer": "Litigio",
      "mortgage_lending_law": "Ley de hipotecas y préstamos",
      "neighbor_hoa_disputes": "Disputas entre vecinos y asociaciones de propietarios",
      "property_damage": "Daños a la propiedad",
      "purchase_agreements": "Acuerdos de compra",
      "real_estate_contracts_transactions": "Transacciones inmobiliarias",
      "real_estate_lawyer_other": "Otro",
      "residential_real_estate": "Bienes raíces residenciales",
      "title_services": "Servicios de azulejos",
      "trespassing": "Allanamiento",
      "rehab_other": "Otro",
      "attic_venting": "Ventilación del ático",
      "gutter_installation": "Instalación de canalones",
      "gutter_repair": "Reparación de canalones",
      "roof_inspection": "Inspección de tejados",
      "roof_installation": "Instalación de tejados",
      "roof_repair": "Reparación de tejados",
      "roofer_other": "Otro",
      "skylight_installation": "Instalación de claraboyas",
      "skylight_repair": "Reparación de tragaluces",
      "storm_wind_damage_roof_repair": "Reparación de daños en el tejado",
      "sewage_cleaning": "Limpieza",
      "sewage_excavation": "Excavación",
      "sewage_inspection": "Inspección",
      "sewage_installation": "Instalación",
      "sewage_locating": "Localización",
      "sewage_maintenance_repairs": "Mantenimiento y reparaciones",
      "sewage_pro_other": "Otro",
      "sewage_pumping": "Bombeo",
      "sewage_removal_demolition": "Eliminación o demolición",
      "remodeling_siding_pro": "Remodelaciones",
      "repair_maintenance_siding_pro": "Reparación y mantenimiento",
      "siding_installation": "Instalación de revestimiento",
      "siding_pro_other": "Otro",
      "siding_removal": "Eliminación de revestimientos",
      "smart_home_other": "Otro",
      "commercial_snow_removal": "Eliminación de nieve comercial",
      "residential_plowing": "Limpieza de nieve en zonas residenciales",
      "residential_shoveling_blowing": "Retirada de nieve con pala sopladora en zonas residenciales",
      "salt_sand_deicing": "Sal, arena y descongelación",
      "snow_relocation": "Reubicación de nieve",
      "snow_removal_other": "Otro",
      "body_polish": "Exfoliante corporal",
      "body_wrap": "Envoltorio corporal",
      "facial": "Facial",
      "hydrotherapy": "Hidroterapia",
      "manicure": "Manicura",
      "massage": "Masaje",
      "pedicure": "Pedicura",
      "peels": "Exfoliación",
      "spa_other": "Otro",
      "spa_packages": "Paquetes de Spa",
      "tanning": "Bronceado",
      "waxing": "Depilación",
      "civil_tax_litigation": "Litigios fiscales civiles",
      "corporate_taxes": "Tasas corporativas",
      "criminal_tax_litigation": "Litigios fiscales penales",
      "estate_tax_planning": "Planificación fiscal patrimonial",
      "failure_to_file": "Falta de presentación",
      "innocent_spouse_relief": "Exoneración de responsabilidad fiscal del cónyuge inocente",
      "international_tax_services": "Servicios fiscales internacionales",
      "irs_tax_problems": "Problemas fiscales con el IRS",
      "non_collectible_status": "Estado no cobrable",
      "offer_in_compromise": "Oferta de compromiso",
      "tax_audits": "Auditorías fiscales",
      "tax_lawyer_other": "Otro",
      "tax_liens_levies": "Embargos fiscales y gravámenes",
      "tax_planning_lawyer": "Planificación fiscal",
      "tax_relief": "Exención fiscal",
      "accounting_support": "Asistencia contable",
      "business_incorporation_restructuring": "Constitución y reestructuración",
      "cryptocurrency_taxes": "Tasas sobre las criptomonedas",
      "irs_audit_representation": "Representación en auditorías del IRS",
      "irs_filing": "Declaración ante el IRS",
      "irs_problem_consulting": "Consultoría de problemas del IRS",
      "new_business_services": "Nuevos servicios empresariales",
      "payroll_support": "Asistencia de nóminas",
      "tax_planning_tax_specialist": "Planificación fiscal",
      "tax_preparation": "Preparación de impuestos",
      "tax_problem_consulting_tax_specialist": "Asesoramiento sobre problemas fiscales",
      "tax_specialist_other": "Otro",
      "therapist_other": "Otro",
      "battery_service": "Servicio de batería",
      "car_towing": "Remolque de coches",
      "fuel_delivery": "Entrega de combustible",
      "local_hauling": "Transporte local",
      "long_distance_hauling": "Transporte de larga distancia",
      "motorcycle_towing": "Remolque de motocicletas",
      "special_vehicle_towing": "Remolque de vehículos especiales",
      "tire_change": "Cambio de neumáticos",
      "towing_other": "Otro",
      "case_assessment_traffic_lawyer": "Evaluación de casos",
      "cdl_traffic_ticket": "Multa de tráfico CDL",
      "dui_dwi_traffic_lawyer": "Conducción bajo los efectos de sustancias psicoactivas",
      "fixit_ticket": "Multa de reparación",
      "parking_ticket": "Multa de estacionamiento",
      "reckless_driving_traffic_lawyer": "Conducción temeraria",
      "red_light_ticket": "Multa por semáforo en rojo",
      "speeding_ticket": "Multa por exceso de velocidad",
      "suspended_license": "Licencia suspendida",
      "traffic_lawyer_other": "Otro",
      "traffic_ticket": "Multa de tráfico",
      "cabling_and_bracing": "Cableado y apuntalamiento",
      "stump_removal": "Eliminación de tocones",
      "tree_planting": "Plantación de árboles",
      "tree_removal": "Eliminación de árboles",
      "tree_service_other": "Otro",
      "tree_transplanting": "Trasplante de árboles",
      "tree_trimming_and_pruning": "Poda y recorte de árboles",
      "tutor_computer_science": "Ciencias de la computación",
      "tutor_foreign_languages": "Idiomas extranjeros",
      "tutor_geography": "Geografía",
      "tutor_government_and_economics": "Gobierno y economía",
      "tutor_history": "Historial",
      "tutor_homework_help": "Ayuda con los deberes",
      "tutor_math": "Matemáticas",
      "tutor_other": "Otro",
      "tutor_reading_and_writing": "Lectura y escritura",
      "tutor_science": "Ciencia",
      "tutor_special_education": "Educación especial",
      "tutor_test_pre_college_entrance": "Preparación de pruebas: ingreso a la universidad",
      "tutor_test_prep_grad_school_entrance": "Preparación para pruebas: ingreso a la escuela de posgrado",
      "tutor_test_prep_k8": "Preparación de pruebas: K-8",
      "area_rug_cleaning": "Limpieza de alfombras",
      "drapery_and_blind_cleaning": "Limpieza de cortinas y persianas",
      "leather_cleaning": "Limpieza de cuero",
      "mattress_cleaning": "Limpieza de colchones",
      "upholstery_cleaner_other": "Otro",
      "upholstery_cleaning": "Limpieza de tapicería",
      "upholstery_water_damage_cleanup": "Limpieza de daños por agua",
      "bird_exotic_animal_care": "Cuidado de aves y animales exóticos",
      "farm_barn_animal_care": "Cuidado de animales de granja y establo",
      "microchipping": "Microchips",
      "veterinarian_allergies": "Alergias",
      "veterinarian_behavior_counseling": "Asesoramiento conductual",
      "veterinarian_dental_care": "Cuidado dental",
      "veterinarian_dermatology": "Dermatología",
      "veterinarian_emergency_care": "Atención de emergencia",
      "veterinarian_end_of_life_care": "Cuidados al final de la vida",
      "veterinarian_examinations": "Exámenes",
      "veterinarian_nutrition_counseling": "Asesoramiento nutricional",
      "veterinarian_other": "Otro",
      "veterinarian_preventive_care": "Atención preventiva",
      "veterinarian_spay_neuter": "Esterilizar o castrar",
      "veterinarian_surgery": "Cirugía",
      "veterinarian_vaccinations": "Vacunas",
      "aerial_videography": "Videografía aérea",
      "documentary_video_production": "Producción de documentales",
      "family_video_production": "Producción de vídeos familiares",
      "live_streaming": "Transmisión en directo",
      "photography": "Fotografía",
      "product_demonstrations": "Demostración de producto",
      "promotional_video_production": "Producción de vídeos promocionales",
      "real_estate_video_production": "Producción de vídeos inmobiliarios",
      "special_event_video_production": "Producción de vídeos para eventos especiales",
      "video_editing": "Edición de vídeo",
      "videographer_other": "Otro",
      "voice_overs": "Voz en off",
      "wedding_video_production": "Producción de vídeos de bodas",
      "fire_damage_cleanup_repair": "Limpieza/reparación de daños por fuego",
      "water_damage_cleanup_repair": "Limpieza de daños por agua",
      "water_damage_flooring": "Suelos",
      "water_damage_mold_inspection": "Inspección de moho",
      "water_damage_mold_removal": "Eliminación de moho",
      "water_damage_other": "Otro",
      "water_damage_painting": "Pintura",
      "water_damage_pest_control": "Control de plagas",
      "water_damage_plumbing": "Fontanería",
      "water_damage_remodeling": "Remodelaciones",
      "water_damage_roofing": "Cubiertas",
      "water_damage_sewage_cleanup": "Limpieza de alcantarillas",
      "adult_weight_loss_programs": "Programas de pérdida de peso para adultos",
      "diet_and_nutrition_counseling": "Asesoramiento en dietética y nutrición",
      "kids_weight_loss_programs": "Programas de pérdida de peso para niños",
      "metabolic_testing": "Pruebas metabólicas",
      "weight_loss_consultation_and_training": "Asesoramiento y formación",
      "weight_loss_fitness_programs": "Programas de acondicionamiento físico",
      "weight_loss_meal_planning": "Planificación de comidas",
      "weight_loss_personal_training": "Entrenamiento personal",
      "weight_loss_service_other": "Otro",
      "weight_loss_wellness_programs": "Programas de bienestar",
      "glass_and_mirror_cleaning": "Limpieza de vidrios y espejos",
      "gutter_cleaning": "Limpieza de canalones",
      "power_pressure_washing": "Lavado a presión",
      "rooftop_skylight_cleaning": "Limpieza de azoteas/tragaluces",
      "window_cleaner_other": "Otro",
      "window_cleaning": "Limpieza de ventanas",
      "door_installation": "Instalación de puertas",
      "door_repair": "Reparación de Puertas",
      "glass_installation": "Instalación de vidrios",
      "window_boardup": "Tablero",
      "window_installation": "Instalación de ventanas",
      "window_repair": "Reparación de ventanas",
      "window_repair_other": "Otro",
      "install_new_wiper_blades": "Instalar nuevas escobillas limpiaparabrisas",
      "repair_power_window": "Reparar ventana eléctrica",
      "repair_water_leak": "Reparar fuga de agua",
      "repair_windshield": "Reparar parabrisas",
      "replace_rear_window": "Reemplazar ventana trasera",
      "replace_side_view_mirrors": "Reparar los espejos laterales",
      "replace_side_window": "Reemplazar ventana lateral",
      "replace_sunroof": "Reemplazar cristal del techo solar",
      "replace_windshield": "Reemplazar parabrisas",
      "windshield_other": "Otro",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Yoga con calor",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditación",
      "power_yoga": "Power Yoga",
      "restorative": "Restaurativo",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Otro"
    }
  }
}
